export default {
  message: {
    abm: {
      folders: {
        errors: {
          '10001': 'idCarpeta é um valor requerido',
          '10002': 'idCarpeta não é um valor inteiro válido',
          '10003': 'nome é um valor requerido',
          '10004': 'nome não é um valor alfanumérico válido',
          '10005': 'tipo é um valor requerido',
          '10006': 'tipo não é um valor alfanumérico válido',
          '10007': 'visível é um valor requerido',
          '10008': 'visível não tem um valor booleano válido',
          '10009': 'assinável não tem um valor booleano válido',
          '10010': 'efêmero não tem um valor booleano válido',
          '10011': 'O nome de usuário não é um valor alfanumérico válido',
          '10012': 'idTemplate não é um valor inteiro válido',
          '10013': 'sinCodigo não tem um valor booleano válido',
          '10014': 'parser não é um valor alfabético válido',
          '10015': 'Já tem uma subpasta com esse nome',
          '10016': 'Já tem uma subpasta com esse nome de usuário',
          '10017': 'template inválido',
          '10018': 'Já tem uma pasta com esse id',
          '10019': 'idSubCarpeta is not a valid number',
          '10020': 'Não existe uma subpasta com esse id',
          '10021': 'Esta subpasta não pode ser eliminada',
          '10022': 'Não é possível modificar o valor do tipo',
          '10023': 'idTemplate é um valor requerido',
          '10024':
            'Não é possível adicionar um idTemplate com visível desabilitado',
          '10025': 'Faltam parâmetros',
          '10026': 'Os parâmetros estão vazios',
          '10027': 'name não é um valor alfanumérico válido',
          '10028': 'Uma ou várias pastas não podem ser bloqueadas',
          '10029': 'order não é um valor inteiro válido',
          '10030': 'O nome desta pasta não pode ser modificado',
          '10031': 'Não pode ser efêmero com assinável desativado',
          '10032': 'Não é possível bloquear com visível desabilitado',
          '10033': 'name é um valor requerido',
          '10034': 'assinável é um valor requerido',
          '10035': 'efêmero é um valor requerido',
          '10036': 'Já existe uma pasta com esse nome no sistema',
          '10037': 'Não pode ser assinável com visível desativado',
          '10038':
            'Não foi possível eliminar a pasta. A pasta contém documentos carregados.',
          '10039': 'Não tem posicionamento de assinatura por default',
          '10040': 'Sem posicionamento de assinatura para essa subpasta',
          '10041': 'O diretório não existe',
          '10042': 'Não foi possível criar o pdf',
          '10043':
            'Não foi possível adicionar o arquivo de posicionamento da assinatura',
          '10044': 'Não foi possível criar a imagem em miniatura',
          '10045': 'Não foi possível salvar no storage',
          '10046':
            'Não foi possível eliminar o arquivo de posição da assinatura',
          '10047': 'Não foi possível eliminar a posição da assinatura',
          '10048': 'A paginação não é um valor de string válido',
          '10049': 'Não foi possível processar o corte do PDF',
          '10050': 'O valor de rotação é inválido',
          '10051': 'Arquivo PDF não válido',
          '10052': 'O PDF ultrapassa o tamanho máximo de 5MB',
          '10053': 'A assinatura do colaborador é um valor requerido',
          '10054': 'Formato de assinatura do colaborador é inválido',
          '10055': 'Formato de assinatura do empregador é inválido',
          '10056': 'File é um valor requerido',
          '10057':
            'Não é possível editar este tipo de documento porque o identificador único não foi definido corretamente. Entre em contato com suporte',
          '10058': 'Não foi possível adicionar o posicionamento da assinatura',
          '10059':
            'Não foi possível eliminar a pasta, existem filtros por pasta associados a alguns usuários',
          '10061': 'O parâmetro sendIa é um valor requerido',
          '268': 'Este PDF está encriptado e não pode ser processado',
          unknown: 'Erro desconhecido',
          PAYSLIP_FOLDER_SHOULD_NOT_BE_DELETED:
            'A pasta de contracheques não pode ser eliminada',
          SYSTEM_API_INVALID_PDF_FILE_SIZE:
            'O PDF ultrapassa o tamanho máximo de 5MB.',
          SYSTEM_API_MAX_FILE_SIZE_EXCEEDED:
            'O PDF ultrapassa o tamanho máximo de 5MB.',
          SYSTEM_API_WRONG_MIME_TYPE: 'O tipo suportado é arquivos PDF.',
          NO_SUPPORTED:
            'O tamanho do PDF a ser carregado pode ser A3, A4, A5, Legal, Carta ou Minimo <span class="font-bold">147mm x 209mm</span> e Máximo <span class="font-bold">298mm x 421mm</span> ',
          THERE_HAS_SUBFOLDER_WITH_IA_ACTIVE:
            'O tipo de documento {docName} já tem habilitada a opção de análise por IA.',
          THERE_HAS_SUBFOLDER_WITH_IA_ACTIVE_DESCRIPTION:
            'Este atributo unicamente pode estar disponível para um tipo de documento.'
        },
        modals: {
          cancelFolder: {
            title: 'Configuração de pastas',
            label: 'Tem certeza de que quer sair da configuração de pasta?',
            label1:
              'Todas as alterações realizadas nesta configuração serão descartadas',
            buttonSecondary: 'Cancelar',
            buttonPrimary: 'Sim, sair'
          },
          cancelSubFolder: {
            title: 'Sair da configuração de tipo documento',
            label: 'Tem certeza de que quer sair da configuração de',
            label1: 'tipo de documento',
            label2:
              'Todas as alterações realizadas nesta configuração serão descartadas',
            label3:
              'Você pode continuar com a criação de documentos a qualquer hora',
            buttonSecondary: 'Cancelar',
            buttonPrimary: 'Sim, sair'
          },
          deleteFolder: {
            title: 'Eliminar pasta',
            label: 'Tem certeza de que quer eliminar a pasta',
            label1:
              'Também serão eliminados os tipos de documentos associados.',
            label2: 'Esta ação não pode ser desfeita',
            buttonSecondary: 'Cancelar',
            buttonPrimary: 'Sim, eliminar',
            buttonOk: 'Ok'
          },
          deleteSubFolder: {
            title: 'Eliminar tipo de documento',
            label: 'Tem certeza de que quer eliminar',
            label1: ' Esta ação não pode ser desfeita',
            buttonSecondary: 'Cancelar',
            buttonPrimary: 'Sim, eliminar',
            buttonOk: 'Ok',
            buttonDeletePrimary: 'Sim, eliminar'
          },
          deleteSubFolderConfig: {
            label:
              'Tem certeza de querer eliminar a configuração atual do documento?'
          },
          emailPreview: {
            title: 'Vista prévia',
            label: 'Olá',
            label1:
              'Informamos que possui um novo documento pendente de assinatura no seu painel de Sichern',
            label2: 'Fazer login',
            label3: 'Cumprimentos',
            label4: 'Equipe de',
            label5:
              'NOTA: Favor não responder esta mensagem já que foi gerada automaticamente em Sichern. Esta comunicação (incluídos seus anexos) contém informação confidencial, dirigida exclusivamente para seu destinatário, quem deverá resguardar a confidencialidade. É proibido a divulgação, modificação, reprodução ou uso da informação aqui contida por qualquer outra pessoa que não seja seu destinatário',
            buttonPrimary: 'Fechar vista prévia'
          },
          generic: {
            title: 'Configuração de pastas',
            buttonPrimary: 'Entendido'
          },
          cancelSubFolderConfig: {
            cancelQuestion:
              'Deseja aplicar as alterações antes de sair da configuração do documento?',
            dismiss: 'Ignorar',
            ok: 'Sim, aplicar'
          },
          confirmSubFolderConfig: {
            confirmQuestion:
              'Tem certeza de que quer salvar as alterações realizadas no documento?',
            ok: 'Aceitar'
          }
        },
        settings: {
          folderName: {
            default: 'Nova Pasta',
            question: 'Qual o nome desta pasta?',
            description:
              'O nome da pasta vai servir para identificar os documentos que foram salvos nela, tente que seja um nome descritivo'
          },
          persistDocument: {
            question: 'Os documentos permanecem no painel do seu colaborador?',
            description:
              'Todos os documentos vão permanecer na caixa de entrada do seu colaborador para que possam ser visualizados, descarregados e impressos',
            option: {
              label: 'Visíveis',
              legend:
                'Depois de assinados, ficam na caixa de entrada do seu colaborador'
            },
            option1: {
              label: 'Ocultá-los',
              legend:
                'Depois de assinados, ficam na caixa de entrada do seu colaborador'
            }
          },
          requiresSignature: {
            question: 'Necessita assinatura do colaborador?',
            description:
              'Os documentos desta pasta vão aparecer na caixa de entrada do seu colaborador para ele assinar',
            option: {
              label: 'Necessita assinatura'
            },
            option1: {
              label: 'Não necessita assinatura'
            }
          },
          signaturePriority: {
            question: 'Esta pasta tem prioridade para ser assinada?',
            question1: 'Selecione a pasta que tem prioridade de assinatura',
            description:
              'O colaborador tem que assinar primeiro os documentos desta pasta para continuar depois com os outros documentos',
            description1:
              'Esta pasta é prioritária e necessita assinatura do colaborador',
            option: {
              label: 'Não tem prioridade'
            },
            option1: {
              label: 'Tem prioridade'
            },
            select: 'Selecione a pasta',
            placeholder: 'Procure ou selecione da lista',
            selectLabel: 'Pressione enter para selecionar',
            selectGroupLabel: 'Pressione enter para selecionar o grupo',
            selectedLabel: 'Selecionada',
            deselectLabel: 'Pressione enter para eliminar',
            deselectGroupLabel:
              'Pressione enter para anular a seleção de grupo',
            noResult: 'Não se encontraram resultados'
          },
          visibleDocuments: {
            question:
              'Os documentos são visíveis na caixa de entrada do seu colaborador?',
            description:
              'Todos os documentos vão ser visíveis na caixa de entrada do seu colaborador para ele poder visualizá-los, descarregar e imprimi-los',
            option: {
              label: 'Sim, são visíveis',
              legend:
                'Os documentos aparecem na caixa de entrada do seu colaborador'
            },
            option1: {
              label: 'Não, ocultá-los',
              legend:
                'Os documentos não aparecem na caixa de entrada do seu colaborador'
            }
          },
          defaultPosition: {
            label: 'Você pode substituir este arquivo em',
            label1: 'subir pdf'
          },
          deleteSignature: {
            label: 'Eliminar assinatura',
            question:
              'Você quer eliminar a assinatura configurada para esta pasta?',
            buttonSecondary: 'Cancelar',
            buttonPrimary: 'Sim, eliminá-la'
          },
          positionSignature: {
            question: 'Como você prefere posicionar a assinatura no documento?',
            description:
              'Localiza no documento o espaço onde impactarão as assinaturas feitas pelo colaborador',
            option: {
              label: 'Não mostrar assinatura'
            },
            option1: {
              label: 'Mostrar assinatura'
            },
            label: 'Editar',
            label1: 'Estabelecer localização da assinatura'
          },
          signatureTools: {
            label: 'Utilizar pdf próprio',
            label1: 'Carregar pdf',
            label2: 'Eliminar pdf',
            label3: 'Você quer eliminar o pdf?',
            label4: 'Esta ação não pode ser desfeita',
            label5: 'Página a ser assinada',
            label6: 'Primeira',
            label7: 'Ultima',
            label8: 'Personalizar',
            label9: 'O numero de página é inexistente',
            label10: 'Orientação',
            label11: 'Vertical',
            label12: 'Horizontal',
            label13: 'Tamanho papel',
            label14: 'Formato',
            buttonSecondary: 'Cancelar',
            buttonPrimary: 'Sim, eliminar',
            buttonPrimary1: 'Aceitar'
          },
          documentIdentificator: {
            question:
              'Como você quer utilizar o identificador único no documento?',
            description:
              'Você pode selecionar a forma de detectá-lo dentro do documento, pode ser pelo nome do arquivo ou fazendo uma digitalização da primeira página dentro do documento'
          },
          alias: {
            question:
              'Você quer alterar o nome do documento enviado por e-mail?',
            description:
              'Você pode alterar o nome do documento que recebe o seu colaborador no seu e-mail para que seja mais fácil de identificar',
            option: {
              label: 'Utilizar o nome por default',
              legend: 'O nome por default que tem o documento'
            },
            option1: {
              label: 'Alterar o nome do documento',
              legend: 'Trocar o nome do documento por outro mais descritivo'
            },
            preview: 'Vista prévia do e-mail'
          },
          documentType: {
            question: 'Este tipo de documento é um formulário digital?',
            option: {
              label: 'Sim'
            },
            option1: {
              label: 'Não'
            }
          },
          documentXML: {
            question: 'Deve anexar documento XML?',
            option: {
              label: 'Sim'
            },
            option1: {
              label: 'Não'
            }
          },
          loadDocument: {
            question: 'O colaborador pode carregar este tipo de documentos?',
            question1: 'Quantas páginas deste documento são necessárias?',
            description:
              'Seu colaborador pode carregar este tipo de documento na plataforma para você receber e executar ações',
            description1:
              'É necessário você selecionar a quantidade de páginas totais do documento e quantas páginas são obrigatórias',
            option: {
              label: 'Não carrega documentos',
              legend: 'O colaborador não pode carregar este tipo de documentos'
            },
            option1: {
              label: 'Carrega documentos',
              legend: 'O colaborador pode carregar este tipo de documentos'
            }
          },
          subFolderName: {
            default: 'Tipo de documento',
            question: 'Qual o nome deste tipo de documento?',
            description:
              'O nome do tipo de documento vai ser útil para identificá-los, tente utilizar um nome descritivo',
            placeholder: 'O nome do tipo de documento',
            configuration: {
              question: 'Configuração do documento',
              description:
                'Você poderá rotar, cortar o documento e estabelecer o posicionamento das assinaturas nele.',
              label: 'Configurar',
              applied: 'Configurações aplicadas',
              deleteConfig: 'Eliminar configuração atual',
              notApplied: 'Este documento não possui configurações aplicadas'
            }
          },
          genericDocument: {
            question: 'O documento corresponde a uma publicação genérica?',
            description:
              'Enviar um mesmo documento massivamente a mais de um colaborador sem necessidade de ele possuir um identificador único',
            option: {
              label: 'Não é uma publicação genérica',
              legend: ''
            },
            option1: {
              label: 'É uma publicação genérica',
              legend: ''
            }
          },
          AiDocument: {
            question:
              'O colaborador pode enviar este documento para ser analisado por IA?',
            description:
              'O colaborador poderá interagir com IA para fazer consultas sobre o documento. Este atributo só pode estar disponível para um tipo de documento',
            option: {
              label: 'Não habilitar',
              legend: ''
            },
            option1: {
              label: 'Habilitar',
              legend: 'Este tipo de documento poderá ser enviado a IA'
            }
          },
          salaryReceipt: {
            question: 'O tipo de documento é um contracheque?',
            option: {
              label: 'Sim'
            },
            option1: {
              label: 'Não'
            }
          }
        },
        table: {
          perPage: 'Quantidade por página',
          eform: 'Formulário',
          pdfxml: 'PDF+XML',
          documentType: 'Tipos de documentos',
          modified: 'Modificado <b>{update_at}</b> por <b>{update_fullname}</b>'
        },
        folderEmpty: {
          label: 'Isto é um deserto...',
          label1: 'Ainda não tem pastas criadas',
          link: 'Criar pasta'
        },
        subFolderEmpty: {
          label: 'está vazia',
          label1: 'Você quer criar um tipo de documento?',
          buttonPrimary: 'Criar tipo de documento',
          buttonSecondary: 'Em outro momento'
        },
        folderList: {
          title: 'Pastas criadas',
          buttonPrimary: 'Criar pasta',
          header: {
            name: 'Nome da pasta',
            visible: 'Visível para funcionário',
            signature: 'Necessita assinatura',
            ephemeral: 'Ocultar depois de assinado'
          }
        },
        subFolderList: {
          buttonPrimary: 'Criar tipo de documento',
          header: {
            name: 'Nome tipo documento',
            documents: 'Documentos genéricos',
            publish: 'Colaborador pode publicar',
            signature: 'Posição de assinatura'
          }
        },
        title: 'Configuração de pastas',
        tooltipFolder: 'A pasta possui documentos dentro',
        deleteFolder: 'Eliminar pasta',
        cancelFolder: 'Cancelar',
        saveFolder: 'Salvar pasta',
        tooltipSubFolder: 'O tipo de documento possui documentos dentro',
        deleteSubFolder: 'Eliminar tipo de documento',
        cancelSubFolder: 'Cancelar',
        saveSubFolder: 'Salvar documento',
        toolbox: {
          deletePdf: 'Eliminar PDF',
          questionPdf: 'Você quer eliminar o PDF?',
          notUndo: 'Esta ação não pode ser desfeita',
          cancel: 'Cancelar',
          confirmDelete: 'Eliminar',
          cutPdf: 'Selecionar a área de recorte dentro do documento',
          applyCut: 'Aplicar recorte',
          applying: 'Aplicando corte...',
          cutDone: 'Corte realizado',
          undo: 'Reiniciar',
          undoTitle: 'Reiniciar documento',
          questionUndo:
            'Esta ação reverterá todos os ajustes de rotação e corte aplicados no documento',
          confirmUndo: 'Reiniciar',
          rotation: 'Você pode rotar o documento 90°',
          leftDir: 'Rotar para a esquerda',
          rightDir: 'Rotar para a direita',
          undoRotation:
            'Esta ação reverterá todos os ajustes de rotação e corte aplicados no documento',
          signShow: 'Mostrar assinatura no documento',
          singDescription:
            'Você pode configurar a posição da assinatura e a página do documento onde quiser que apareça',
          firstPage: 'Primeira',
          lastPage: 'Última',
          customPage: 'Personalizar',
          singQuestion:
            'Você quer voltar ao posicionamento de assinar por default?',
          singEmpQuestion:
            'Você quer desfazer a alteração de posicionamento de assinatura do empregador?',
          loading: 'Carregando...',
          cut: 'Cortar',
          rotate: 'Rotar'
        },
        signatureTool: {
          singEmployee: 'Assinatura colaborador',
          singDescription: 'Aqui vai aparecer a assinatura do colaborador',
          singEmployer: 'Assinatura Empresa',
          singDescriptionEmployer: 'Aqui vai aparecer a assinatura da Empresa'
        },
        emptyState: {
          title: 'Você pode substituir este arquivo em',
          link: 'carregar pdf'
        },
        pdfInfo: {
          size: 'Tamanho',
          page: 'Página'
        },
        configurationDocumentModal: 'Configuração de documento',
        settingPanel: {
          loadDocument: 'Carregar um documento',
          loadPdf: 'Carregar pdf',
          actions: 'Ações',
          position: 'Posicionamento',
          exit: 'Sair',
          ok: 'Aceitar'
        },
        folderName: 'Nome da pasta',
        fileNameDescription: 'O identificador está incorporado no nome do arquivo',
        searchDocumentDescription:'Escaneamos o documento em busca do identificador único',
        searchDocumentAlias: 'Busca no documento',
        fileNameAlias: 'Nome do arquivo'
      }
    },
    actions: {
      delete: 'Eliminar',
      atention: 'Atenção',
      error: 'Erro',
      not_founded: 'Não encontrado',
      empty_list: 'Lista vazia',
      remove: 'Eliminar',
      empty_user: 'Desculpa, mas não encontramos nenhum usuário',
      max_elements: 'Máximo um elemento selecionado'
    },
    unsubscribe: {
      viewTitle: 'Funcionários',
      dropzone: {
        dragText: 'Arraste o arquivo aqui ou',
        selectText: 'selecione um',
        dictFileTooBig: "Tamanho máximo permitido: {maxFilesize}MB.",
        dictInvalidFileType: "Não é possível enviar este tipo de arquivo.",
        dictRemoveFile: "Remover arquivo",
        dictMaxFilesExceeded: "Não é possível enviar mais de {maxFiles} arquivo."
      },
      reasons: {
        termination: 'Desvinculação',
        contractEnd: 'Fim do contrato',
        resignation: 'Demissão',
        retirement: 'Aposentadoria',
        candidateDrop: 'Baixa de candidato',
        others: 'Outros'
      },
      confirm_unsubscribe_question:
        'Tem certeza que deseja desvincular o funcionário?',
      confirm_unsubscribe_why:
        'Selecione um motivo para dar de baixa o funcionário',
      confirm_unsubscribe_why_title: 'Motivo',
      confirm_unsubscribe_observation: 'Observações',
      confirm_unsubscribe_yes: 'Sim',
      confirm_unsubscribe_no: 'Não',
      confirm_unsubscribe_success: 'O funcionário foi desativado com sucesso',
      date: 'Data de Baixa Legal',
      date_invalid: 'Necessita digitar uma data de baixa',
      title: 'Desvinculação massiva de Funcionários',
      description1:
        'Nesta seção você poderá alterar o estado dos usuários para inativo para eles não receberem mais notícias, solicitarem licenças nem enviarem documentação.',
      description2:
        'Os usuários poderão seguir acessando na plataforma para consultar os documentos que tiverem em sua caixa de entrada.',
      description3:
        'No detalhe do funcionário você poderá reativá-lo, caso necessário.',
      step_1_title: '1. Criar arquivo de usuários',
      step_1_content:
        'Criar um arquivo CSV que contenha todos os usuários que deseje desvincular. ',
      step_1_download_example: 'Você pode descarregar este exemplo ',
      step_1_2_content:
        'para preencher. É importante respeitar o cabeçalho do arquivo como primeira linha.',
      step_2_title: '2. Selecione um motivo',
      step_3_title: '3. Anexar arquivo CSV',
      step_3_extension_dropzone: '*O formato do arquivo deverá ser CSV',
      btn_save: 'Processar arquivo',
      alert_format: 'Formato de arquivo não compatível',
      max_files_reached: 'Só é possível anexar um arquivo',
      count_filename_1: 'Será atualizado o estado de',
      count_filename_2: 'usuários',
      unsubscribe_valid_pass:
        'Tem certeza de que deseja desvincular os funcionários?',
      action_cancel: 'Cancelar',
      action_unsubscribe: 'Desvincular',
      text_fail_password: 'Senha incorreta',
      text_modal_1: 'Sua solicitação está em processo',
      text_modal_2:
        'Você pode voltar para o buscador de funcionários para seguir administrando os funcionários ou para checar a ação realizada no estado de processo.',
      back_to_search: 'Voltar ao buscador',
      action_go_process: 'Ir para o estado de processo',
      error_50024: 'O arquivo não possui informação alguma',
      error_50027:
        'O arquivo está incompleto, especificamente algum campo de identificador único',
      error_50022: 'O arquivo possui formatos de datas inválidas',
      error_50021:
        'O arquivo não pode ser processado, especificamente algum campo de observação é longo demais',
      error_50020: 'O arquivo não pode ser processado, existem campos vazios',
      error_50023: 'O arquivo possui cabeçalhos inválidos',
      error_50028: 'O usuário da sessão atual não pode ser desativado',
      error_50029:
        'O formato do cabeçalho ou os dados não são válidos. Por favor, descarregue o exemplo e siga o formato.',
      error_05010:
        'A data de baixa legal não pode ser menor à data de contratação',
      error_05001:
        'Não foi possível desvincular o funcionário, o campo de usuário identificador é requerido',
      error_05002:
        'Não foi possível desvincular o funcionário, algum campo digitado não tem o formato correto',
      error_05003:
        'Não foi possível desvincular o funcionário, não pode se desvincular a si mesmo',
      error_05004:
        'Não foi possível desvincular o funcionário, não tem permissão para desvincular funcionários',
      error_00005:
        'Não foi possível desvincular o funcionário, faltam preencher campos necessários para desvinculá-lo',
      error_00072:
        'Não foi possível desvincular o funcionário, o usuário especificado não foi encontrado no sistema',
      error_50015:
        'Não foi possível desvincular o funcionário, o usuário identificado pertence a outra empresa',
      error_default: 'Houve um problema na hora de dar de baixa o usuário'
    },
    generalSettings: {
      title: 'Centro de segurança',
      security_title: 'Segurança',
      mfa_subtitle: 'Autenticação multifator (MFA)',
      mfa_table_profile_header: 'Perfis de Gestão',
      mfa_table_required_header: 'Requer MFA',
      mfa_active_modal_title: 'Ativar MFA',
      mfa_active_modal_description:
        'É necessário que os usuários pertencentes a este perfil possuam um e-mail registrado, caso não tiverem, perderão o acesso à conta até registrarem um novo e-mail.',
      mfa_active_modal_cancel: 'Cancelar',
      mfa_active_modal_solicitar: 'Sim, Solicitar',
      mfa_active_modal_confirm: 'Entendido',
      errorLogs: {
        unknown: 'Erro desconhecido',
        parameter_required: 'Faltam parâmetros para realizar a operação',
        mfa_not_granted: 'Não tem permissão para realizar esta operação',
        parameter_lenght_exceeded: 'Parâmetro com valor limite excedido',
        wrong_type_data: 'Parâmetro incorreto',
        parameter_not_expected: 'Parâmetro não esperado',
        mfa_preference_profile_restricted:
          'Não é possível adicionar MFA para este tipo de perfil'
      }
    },
    mfa: {
      email_validation: {
        title: 'Digite um E-mail',
        sub_title_email_empty:
          'Para sua segurança necessitamos verificar sua conta de e-mail associada, por favor, digite um e-mail válido. Enviaremos um código que deverá preencher no seguinte passo.',
        sub_title_email_dirty:
          'Para sua segurança necessitamos verificar sua conta de e-mail associada, por favor, digite um e-mail válido. Enviaremos um código que deverá preencher no seguinte passo.',
        go_back_btn: 'Voltar',
        send_btn: 'Enviar',
        sending_btn: 'Enviando'
      },
      max_exceeded_resend_fails_mails: {
        title: 'Código de verificação',
        sub_title_max_mails_resend_fails:
          'Foram feitos muitos pedidos de verificação, por motivos de segurança sua conta foi desabilitada por 1 hora',
        sub_title_max_code_attempts:
          'Foram feitas muitas tentativas malsucedidas, faça login novamente',
        go_back_login_btn: 'Ir para o login'
      },
      code_authentication: {
        title: 'Código de verificação',
        sub_title_wrong_code:
          'O código de verificação não é válido. Por favor, tente novamente',
        sub_title_valid_code:
          'Digite o código de verificação de 6 números que enviamos para seu e-mail',
        sub_title_expired_code: 'Código expirado',
        sub_title_resend_code: 'Reenviar Código',
        sub_title_time_expired_code: 'O código expira em',
        go_back_btn: 'Voltar',
        send_btn: 'Enviar',
        sending_btn: 'Enviando'
      },
      backup: {
        button: 'Realizar Backup',
        heading: 'Backup de Documentos',
        title: 'Tem certeza de querer solicitar um Backup dos seus documentos?',
        content:
          'O Backup será gerado e enviado por e-mail depois das 72 Horas para confirmar o processo',
        heading_success: 'Solicitação realizada com sucesso!',
        content_success:
          'Depois de gerado o backup receberá no seu e-mail um enlace para sua descarga. A confirmação será recebida 72hs após a solicitação.'
      }
    },
    passwordExpired: {
      go_back_btn: 'Voltar',
      update_pass_btn: 'Atualizar',
      go_to_dashboard: 'Ir para o dashboard',
      pass_expired_message: 'Sua senha expirou. Digite uma nova senha.',
      message_error: {
        error_00019: 'A senha não cumpre com as políticas da empresa',
        error_00026: 'Não pode repetir as últimas 3 senhas',
        error_00033: 'A nova senha não pode ser igual à atual',
        error_00034: 'A senha de verificação de identidade é incorreta',
        error_00141: 'A senha não cumpre com as políticas da empresa',
        error_00024:
          'Houve um problema na hora de atualizar a senha, tente novamente',
        error_00046:
          'Já foram realizadas as alterações de senha máximas permitidas no dia. Sua conta será restabelecida em 24hs',
        error_00017: 'Solicitação incorreta',
        error_00020: 'Token inválido',
        error_00032: 'As senhas não coincidem',
        error_00114:
          'Você ultrapassou a quantidade de alterações de senha permitidas. Consulte com o Administrador',
        error_00115: 'Não foi possível atualizar o registro de senhas',
        error_00116: 'Não pode repetir as últimas',
        error_00117: 'A senha não pode conter informação pessoal do usuário',
        error_00118:
          "Os campos 'Usuário', 'Nome' e 'Sobrenome' são necessários para validar a senha",
        error_00119: 'A senha deve ser de maior complexidade',
        error_00145: 'Deve repetir a nova senha de usuário',
        error_00146: 'As senhas não coincidem',
        error_00147: 'A nova senha não pode ser igual à atual',
        error_00148: 'A senha de comprovação de identidade é incorreta',
        error_00144: 'Erro na hora de auditar a alteração de senha'
      },
      password_validation: {
        required: 'Este campo é requerido',
        no_match_pass: 'As senhas digitadas não coincidem',
        min_character_rule: 'Este campo deve conter, no mínimo, 8 caracteres',
        min_number_rule: 'Este campo deve conter, no mínimo, 1 número',
        min_character_info: 'Mínimo 8 caracteres, 1 número'
      },
      password_policies: {
        title: 'A senha deve conter:',
        history_pass: 'Diferentes das últimas input senhas',
        max_character: 'Máximo input caracteres',
        min_character: 'Mínimo input caracteres',
        no_expire: 'Não expira',
        expire: 'Expira em input dias',
        special_characters_amount: 'No mínimo, input caracteres especiais',
        special_character: 'No mínimo, input caractere especial',
        min_numbers: 'No mínimo, input número',
        min_numbers_plural: 'No mínimo, input números',
        min_capital_letter: 'No mínimo, input maiúscula',
        min_capital_letters_plural: 'No mínimo, input maiúsculas',
        min_letter: 'Mínimo input letra(s)',
        notPersonalInfo: 'Não pode conter informação pessoal do usuário',
        notEasyPassw:
          'A senha não deve ser simples (ex. 12345678, qwerty, admin1234 etc.)'
      },
      success: {
        success_message: 'Senha atualizada com sucesso',
        pls_go_back: 'Por favor, tente fazer login novamente.',
        go_back_btn: 'Voltar para o login'
      }
    },
    publishedEforms: {
      go_back_btn: 'Voltar',
      parent_title: 'Resultado envios',
      title: 'Publicações feitas',
      columns: {
        sendBy: 'Enviado por',
        sendDate: 'Data e Hora',
        docTypes: 'Tipo documento',
        recipients: 'Destinatários',
        status: 'Estado',
        actions: 'Ações'
      },
      paginator: {
        rowsByPage: 'Quantidade por página',
        of: 'de'
      },
      modalRevert: {
        title: 'Reverter envio',
        question: 'Tem certeza de que deseja reverter o envio?',
        bodyContent:
          'Quando reverter o envio, os formulários digitais envolvidos deixarão de ser vistos nas contas de cada colaborador, tenham ou não sido preenchidos.',
        btn_Revert: 'Sim, reverter'
      },
      filter: {
        title: 'Filtros',
        clear_filter_btn: 'Limpar Seleção',
        filter_btn: 'Filtrar'
      },
      recipientsModal: {
        title: 'Destinatários',
        close: 'Fechar',
        viewRecipients: 'Ver destinatários',
        viewDetail: 'Ver detalhe',
        revertSend: 'Reverter envio',
        cancel: 'Cancelar',
        documentType: 'Tipo de documento'
      }
    },
    folderSettings: {
      title: 'Configuração de pastas',
      breadcrumbs_names: {
        0: 'Início',
        1: 'Configuração de pastas'
      },
      subtitle: 'Pastas disponíveis',
      tableHeader: {
        name: 'Nome',
        count: 'Quantidade',
        visible_for_employee: 'Visível para o funcionário',
        signature_required: 'Necessita assinatura',
        hidden_after_signing: 'Oculto depois de assinar'
      },
      folderDetail: {
        visible: 'Visível',
        signature_required: 'Necessita assinatura',
        hidden_for_employee_after_signing:
          'Ocultar para o funcionário lodo de assinado',
        keep_employee_inbox: 'Manter na caixa de entrada do funcionário',
        selected_folder_to_block: 'Selecione pasta a ser bloqueada',
        tooltip_folder_to_block:
          'Selecione as pastas que não poderá acessar até ter assinado todos os documentos contidos nela. Isto é opcional'
      },
      subFolder: {
        title: 'Subpastas',
        tableHeader: {
          name: 'Nome'
        },
        detail: {
          content_eforms: 'Contém formulários digitais',
          allow_generic_docs: 'Permite a publicação de documentos genéricos',
          allow_documents_load_to_employee:
            'Permite carga de documentos por parte do funcionário',
          selected_template_label: 'Selecione template',
          advance_config: {
            title: 'Configuração avançada',
            parser_get_method: 'Método de print',
            alias_alternative_name: 'Nome alternativo'
          }
        },
        create: {
          content_eforms: 'Contém formulários digitais',
          allow_generic_docs: 'Permite a publicação de documentos genéricos',
          allow_documents_load_to_employee:
            'Permite carga de documentos por parte do funcionário',
          selected_template_label: 'Selecione template',
          advance_config: {
            title: 'Configuração avançada',
            parser_get_method: 'Método de print',
            alias_alternative_name: 'Nome alternativo'
          },
          save_btn: 'Salvar',
          input_placeholder_name: 'Nome de subpasta',
          errors: {
            field_required: 'Este campo é requerido'
          },
          modals: {
            create_success: 'A subpasta foi criada com sucesso',
            create_success_signature_position:
              'O posicionamento de assinatura foi configurado por default, para aplicar um outro personalizado entre em contato com suporte',
            create_failed: 'Houve um erro',
            question_exit_create:
              'Tem certeza de que deseja cancelar a criação?'
          }
        },
        delete: {
          modals: {
            question_delete: 'Deseja eliminar a subpasta?',
            delete_success: 'Eliminado com sucesso',
            delete_failed: 'Houve um erro'
          }
        }
      },
      genericModals: {
        confirm_btn: 'Aceitar',
        cancel_btn: 'Cancelar'
      },
      errorLogs: {
        unknown: 'Erro desconhecido',
        id_folder_is_required: 'Id de pasta é obrigatório',
        id_folder_not_valid_integer_value: 'Id de pasta deve ser numérico',
        name_is_required_value: 'O nome é obrigatório',
        name_is_not_valid_alphanumeric_value: 'O nome deve ser alfanumérico',
        type_is_required_value: 'O tipo é obrigatório',
        type_not_valid_alphabetic_value: 'O tipo deve ser alfabético',
        visible_is_required_value: 'Visível é obrigatório',
        visible_does_not_have_valid_boolean_value:
          'Visível só admite verdadeiro/falso',
        signed_does_not_have_valid_boolean_value:
          'Assinável só admite verdadeiro/falso',
        ephemeral_does_not_have_valid_boolean_value:
          'Efêmero só admite verdadeiro/falso',
        alias_is_not_valid_alphanumeric_value:
          'Nome alternativo deve ser alfanumérico',
        id_template_is_not_valid_integer_value: 'Template incorreto',
        without_code_does_not_have_valid_boolean_value:
          'Documentos genéricos só admitem verdadeiro/falso',
        parser_is_not_valid_alphabetic_value:
          'Método de captura deve ser alfabético',
        there_is_sub_folder_with_that_name: 'A subpasta já existe',
        there_is_sub_folder_with_that_alias: 'O nome alternativo já existe',
        there_is_not_template_with_that_id: 'Template incorreto',
        there_is_not_folder_with_that_id: 'A pasta é incorreta',
        id_sub_folder_is_not_valid_number: 'A subpasta é incorreta',
        there_is_not_sub_folder_with_that_id: 'A subpasta é incorreta',
        this_sub_folder_cant_be_remove:
          'A subpasta não pode ser eliminada porque já possui documentos associados',
        type_of_sub_folder_is_not_modify:
          'O valor de (Contém formulários digitais) não pode ser alterado'
      }
    },
    userActive: {
      title_menu_personal_info: 'Informação pessoal',
      title_menu_configuration: 'Editar perfil',
      title_menu_onboarding: 'Onboarding',
      title_menu_licenses: 'Licenças',
      title_menu_documents: 'Documentos',
      title_employee_active: 'Perfil do funcionário',
      subtitle_employee_active: 'Informação do Funcionário',
      subtitle_employee_active_onboarding:
        'Informação fornecida pelo funcionário',
      subtitle_employee_active_onboarding_emergencia: 'Contato de emergência',
      subtitle_employee_configuration_profiles: 'Configuração de perfis',
      subtitle_employee_configuration_int_profiles: 'Perfis de integração',
      change_employee_configuration_profiles: 'Perfis alterados com sucesso',
      change_employee_configuration_profiles_error:
        'Deve selecionar, no mínimo, um perfil',
      profile_employee_title: 'Perfil funcionário',
      profile_management_title: 'Perfis de gestão',
      profile_management_int_title: 'Designar perfis',
      profile_limited_access_title: 'Perfil com acesso limitado',
      profile_employee_tooltip:
        'Perfil desenhado para funcionários com permissão para ver, descarregar e assinar os seus contracheques. Só pode ser selecionado um por usuário.',
      profile_management_tooltip:
        'Perfis desenhados para o pessoal de recursos humanos. Permite administrar dados de usuários, notificações e contracheques. Só pode ser selecionado um por usuário.',
      profile_limited_access_tooltip:
        'Perfil desenhado para o pessoal de recursos humanos com acesso limitado. Permite administrar dados de usuários, notificações e contracheques. Só pode ser selecionado um por usuário. Quando selecionar este perfil, você poderá, a seguir, configurar filtros por setor e/ou locação.',
      title_employee_filter: 'Filtros por setor e locação',
      select_profile: 'Selecione um perfil administrador',
      add_employee_filter: 'Adicionar',
      subtitle_employee_filter: 'Filtros designados',
      name_employee_active_onboarding_emergencia: 'Nome contato de emergências',
      number_employee_active_onboarding_emergencia: 'Telefone',
      usuario: 'Usuário',
      nombre: 'Nome',
      apellido: 'Sobrenome',
      dni: 'Documento de identidade',
      cuil: 'CPF',
      cuils: 'CPF',
      fecha_nacimiento: 'Data de nascimento',
      fecha_contratacion: 'Data de alta',
      numero_legajo: 'Número de registro',
      mail: 'E-mail',
      duplicatedCuil:
        'O identificador está associado a outro usuário, por favor verifique',
      cuilWarningMessage:
        'Ao alterar o Documento de identidade do colaborador detectamos que tem {input} documentos associados no seu perfil. Ao salvar as alterações, os documentos ficarão associados ao novo Documento de identidade.',
      modalCuilMessage:
        'Detectamos que o colaborador <strong>{nombre}</strong> com o CPF <strong>{viejoCuil}</strong> tem <strong>{documentCounter} Documentos</strong> no seu perfil. Os documentos serão associados ao novo CPF <strong>{nuevoCuil}</strong>.<br><br> ‘Se houver algum inconveniente, você pode entrar em contato com suporte',
      warningQuestion:
        'Você quer salvar e associar os documentos históricos do colaborador?',
      warningTitle: 'Salvar alterações',
      warningSave: 'Salvar',
      warningCancel: 'Cancelar',
      information_general_employee_active:
        '(*) Corresponde a informação fornecida pela área de Recursos Humanos',
      policies_employee_active: 'Ver o Nosso Aviso de Privacidade',
      empty_onboarding: 'Nenhum',
      title_position_ubication: 'Cargo e locação',
      position_position_ubication: 'Cargo',
      report_to_position_ubication: 'Reporta a',
      no_filter: 'Não há filtros configurados',
      footer_filter:
        'Os seguintes filtros aplicam ao perfil com acesso limitado',
      profile_employee: 'PERFIL FUNCIONÁRIO',
      profile_hhrr: 'PERFIL RH',
      other_profiles: 'PERFIS',
      remove_profiles: 'Eliminar perfil',
      title_license: 'Configuração de licenças',
      module_license: 'Usa módulo de licenças',
      license_use_module: 'Usa módulo de licenças',
      only_rh: 'Solo RH',
      level_one: 'Aprovador nível 1 e RH',
      level_two: 'Aprovador nível 1 - Aprovador nível 2 e RH',
      tiene_perfil_licencias: 'Perfil licenças',
      tiene_perfil_aprobador: 'É aprovador',
      approve_license_tooltip:
        'Caso selecione esta opção, qualquer funcionário poderá selecionar este usuário como aprovador de sua licença',
      numero_legajo_aprobador: 'Número de registro do aprovador',
      niveles_aprobacion: 'Níveis de aprovação',
      id_politica: 'Políticas',
      antiguedad_previa: 'Antiguidade prévia',
      antiquity_license_tooltip:
        'Caso o funcionário tivesse trabalhado anteriormente na empresa, digite aqui a antiguidade acumulada nesse período indicado em número de meses trabalhados.',
      module_license_tooltip:
        'Quando ativar esta opção poderá configurar os valores do módulo de licenças como aprovadores, políticas aplicáveis etc.',
      subtitle_folders_description:
        'Selecione as pastas que visualizará depois no pesquisador de documentos',
      error_location_seccion_added:
        'O setor e a locação já se encontram adicionados',
      error_startdate: 'A data de contratação é requerida',
      error_borndate: 'A data de nascimento é requerida',
      error_username_change:
        'Deverá restabelecer a senha do funcionário se trocar o nome de usuário',
      error_cuil_change:
        'Se alterar este dado, o usuário perderá os documentos associados',
      error_sector_not_found: 'Setor não disponível',
      error_organization_model_not_found:
        'Modelo de organização não disponível',
      error_locacion_not_found: 'Locação não disponível',
      error_int_profiles_not_found: 'Perfis de integração não disponíveis',
      error_position_not_found: 'Cargo não disponível',
      max_elements: 'Máximo um elemento selecionado',
      profiles_aclaration: 'Selecione o tipo de permissão do usuário',
      folders_aclaration:
        'Selecione as pastas que o usuário de gestão poderá acessar para consultar o seu conteúdo',
      filter_aclaration:
        'Selecione o setor e locação dos funcionários que poderá acessar para visualizar seus documentos',
      empty_location_and_sector_text:
        'Deve digitar, no mínimo, uma locação ou setor',
      human_resources: 'RH',
      select_folders: 'Selecionar pastas',
      select_location: 'Selecione um setor',
      select_position: 'Selecione um cargo',
      select_section: 'Selecione uma locação',
      select_tag_sector:
        'Ao pressionar Enter você pode adicionar um novo setor',
      select_tag_location:
        'Ao pressionar Enter você pode adicionar uma nova locação',
      select_tag_position:
        'Ao pressionar Enter você pode adicionar um novo cargo',
      tiene_licencias_progresivas: 'Licenças progressivas',
      inicio_dias_progresivos: 'Início de dias progressivos',
      fecha_inicio_licencias_progresivas: 'Data de início dias progressivos',
      search_combo_reporta_a: 'Faça uma pesquisa...',
      estado: 'Estado',
      activo: 'Ativo',
      inactivo: 'Inativo',
      onboarding: 'Onboarding',
      noSector: 'SEM SETOR',
      noLocation: 'SEM LOCAÇÃO',
      requiredDate: 'É necessário preencher "Data de alta"',
      textFindLegajo: 'Faça a pesquisa do número de registro',
      noFilterSLxSector:
        'Não foi selecionado um filtro por setor e locação. O usuário poderá administrar funcionários do setor e locação ao qual pertence',
      noFilterSLrrhh:
        'Não foi selecionado um filtro por setor e locação. O usuário poderá administrar todos os funcionários',
      noFilterFolders:
        'Quando aplicar um ou mais filtros por pasta, o usuário unicamente poderá visualizar a documentação nas pastas selecionadas. Se não aplicar nenhum filtro, o usuário poderá visualizar todos os documentos dos funcionários que administrar, sem restrição.',
      foldersFilters: 'Filtros por pasta',
      managerProfile:
        'Não foi selecionado um filtro por setor e locação. O usuário unicamente poderá administrar os funcionários que lhe reportam diretamente.',
      alertHasCertSign:
        'Este perfil pode criar certificados eletrônicos. Você não possui permissão para fazer modificações, entre em contato com suporte',
      certSignModal: {
        title: 'Salvar Perfil',
        text_1:
          'Não possui permissão para designar o perfil de certificados eletrônicos',
        text_2:
          'Para designar o perfil com certificado, é necessário você entrar em contato com suporte',
        btnOk: 'Entendido'
      }
    },
    listEmployees: {
      ob_down_employees: 'Baixa massiva',
      tooltip_cargo:
        'Cargo que ocupa o funcionário na empresa. Atualizável de forma massiva por CSV em "Carga massiva" ou de forma individual no detalhe do funcionário',
      tooltip_report:
        'Chefe direto.  Atualizável de forma massiva por CSV em "Carga massiva" ou de forma individual no "Perfil do funcionário"'
    },
    login: {
      title_switch: 'Selecionar Empresa',
      name_btn_switch: 'Login',
      forgot_password: 'Foi enviado um e-mail com as instruções',
      err404ForgotPass:
        'O usuário / e-mail não foi encontrado, por favor verifique os dados digitados '
    },
    sso: {
      msgRedirectAuth: 'Autenticando...',
      msgRedirectLogin: 'Acessando Sichern',
      msgRedirectErrorLogin:
        'Houve um erro na hora de autenticar o usuário Tente novamente',
      msgRedirectLoginRRHH: 'Você deve ser administrador para acessar'
    },
    homeComponent: {
      birthdays: {
        title: 'Aniversários',
        no_events: 'Sem eventos',
        before_yesterday: 'Anteontem',
        yesterday: 'Ontem',
        today: 'Hoje',
        tomorrow: 'Amanhã',
        after_tomorrow: 'Depois de amanhã'
      },
      recentHired: {
        title: 'Altas do mês',
        no_events: 'Sem eventos',
        show_more: 'Mostrar mais',
        show_minus: 'Mostrar menos',
        teammate: 'Colegas de equipe'
      },
      absentUsers: {
        title: 'Ausências'
      },
      greeting: 'Olá',
      quick: 'Acessos Rápidos'
    },
    searchComponent: {
      not_founded: 'Não encontrado',
      max_elements: 'Máximo um elemento selecionado',
      fileNumber: 'Número de registro',
      sectionName: 'Pesquisador de documentos',
      folder: 'Pasta',
      document: 'Documento',
      signed: {
        from: 'Assinado desde',
        to: 'Assinado até'
      },
      created: {
        from: 'Criação desde',
        to: 'Criação até'
      },
      period: {
        from: 'Período desde',
        to: 'Período até'
      },
      eforms: 'Formulários Digitais',
      searchAdvance: 'Pesquisa avançada',
      cleanFilters: 'Limpar filtros',
      search: 'Pesquisar',
      employee: 'Usuário',
      searchBy:
        'Você pode pesquisar por Nomes, Sobrenomes, Cédula de identidade',
      searchBy2:
        'Você pode pesquisar por Nomes, Sobrenomes, Registration Number',
      searchBy3:
        'Você pode pesquisar por Nomes, Sobrenomes, Documento de identidade',
      searchBy4: 'Pesquisa por',
      documentType: 'Tipo de documento',
      status: 'Status',
      goTo: 'Ir para',
      page: 'página',
      total: 'Total',
      download: 'Descarregar',
      downloadSelected: 'Descarregar seleção',
      searchDownloadText: 'Descarregando...',
      order: {
        ascending: 'Ascendente',
        descending: 'Descendente'
      },
      items: {
        creationDate: 'Data de criação',
        name: 'Sobrenome e Nome',
        status: 'Status',
        location: 'Locação',
        period: 'Período',
        sector: 'Setor',
        docType: 'Tipo de documento'
      },
      added: 'Adicionados',
      add100: 'Você pode adicionar até 100',
      separator: 'separados por vírgulas',
      selectAll: 'Selecionar tudo',
      remove: 'Apagar {selectedCuils} selecionados',
      visor: 'Aqui serão visualizados',
      added1: 'Todos os {CPFs} adicionados',
      added2: 'Todos os {CPFs} adicionados',
      apply: 'Aplicar',
      documentActives: 'Só documentos de funcionários ativos',
      user: 'Funcionário',
      searchLimit:
        'A pesquisa permite um máximo de 100 {CPFs} separado por vírgulas',
      sectorAndLocation: 'Setor e Locação',
      sectors: 'Setores',
      locations: 'Locações',
      filters: {
        hide: 'Ocultar filtros',
        show: 'Mostrar filtros'
      },
      empty: {
        message: 'Os resultados de sua pesquisa serão mostrados aqui',
        legend:
          'Para fazer uma pesquisa você pode preencher o Nome, Sobrenome, Código de identificação nos campos de pesquisa ou selecionar uma combinação de filtros.'
      },
      emptyResults: {
        message: 'Não foram encontrados os resultados para a pesquisa',
        legend:
          'Para realizar uma pesquisa você pode preencher o Nome, Sobrenome ou Código de identificação nos campos de pesquisa ou selecionar uma combinação de filtros.'
      },
      noUser: 'Funcionário inexistente',
      noDoc: 'Documento não disponível'
    },
    label: {
      dni: 'CPF'
    },
    downloadBackup: {
      cancel: 'Cancelar',
      understood: 'Entendido',
      downloadModal: {
        title: 'Descarga de Backup',
        messageInitialDownload:
          'A descarga de documentos se iniciou de forma automática.',
        expiredDownload: 'A descarga de seus documentos expirou',
        problemWithDownloadLink: 'Caso tenha problemas com a descarga',
        clickHere: 'clique aqui',
        retryDownload:
          'Se quiser tentar descarregá-los novamente, vai para o pesquisador de documentos',
        mfaError: 'Você não tem habilitado o fator duplo de segurança (MFA)',
        messageMFA:
          'Você não tem habilitado o fator duplo de segurança (MFA) para executar a ação'
      }
    },
    first_login_terms_conditions: 'Aceito os Termos e Condições',
    change_image_swal_confirm: 'Sim',
    change_image_swal_deleted: 'Imagem eliminada',
    change_image_swal_rejct: 'Não',
    change_image_swal_text: 'Não é possível reverter esta ação!',
    change_image_swal_title: 'Tem certeza',
    ei_title: 'Informação do Funcionário',
    ei_personal_info_title: 'Informação pessoal',
    ei_personal_info_edit: 'Editar',
    ei_personal_send_menssage: 'Enviar mensagem',
    ei_personal_change_password: 'Alterar senha',
    ei_personal_download_file: 'Descarregar registro',
    ei_personal_employee_configuration: 'Configuração funcionário',
    ei_personal_employee_suspend: 'Suspender funcionário',
    ei_personal_employee_unlink: 'Desvincular funcionário',
    ei_personal_employee_change_template: 'Trocar Modelo On-boarding',
    ei_personal_info_save_changes: 'Salvar alterações',
    ei_personal_options_button: 'Mais opções',
    ei_personal_data_title: 'Documentos Pessoais',
    ei_familiares_title: 'Documentos de Familiares',
    ei_personal_formDigital_title: 'Formulários Digitais',
    ei_OnboardingComplete: 'Completo',
    ei_OnboardingIncomplete: 'Incompleto',
    ei_ActiveButton: 'Ativar',
    ei_ActiveEmployee: 'Funcionário ativo',
    ei_InactiveEmployee: 'Funcionário Inativo',
    ei_RefuseImg: 'Rejeitar Imagem',
    ei_titleList_text_1: 'Informação pessoal',
    ei_titleList_text_2: 'Dados de Contato',
    ei_titleList_text_3: 'Endereço',
    ei_titleList_text_4: 'Grupo Familiar',
    ei_titleList_text_5: 'Informação bancária',
    ei_titleList_text_6: 'Dados pessoais',
    ei_titleList_text_1_1: 'Nome *',
    ei_titleList_text_1_2: 'Sobrenome *',
    ei_titleList_text_1_3: 'Documento de identidade *',
    ei_titleList_text_1_4: 'CPF',
    ei_titleList_text_1_5: 'Gênero',
    ei_titleList_text_1_6: 'Data de Nascimento',
    ei_titleList_text_1_7: 'Número de registro',
    ei_titleList_text_1_8: 'Data de Início *',
    ei_titleList_text_2_1: 'Celular',
    ei_titleList_text_2_2: 'E-mail',
    ei_titleList_text_3_1: 'Rua',
    ei_titleList_text_3_2: 'Número',
    ei_titleList_text_3_3: 'País',
    ei_titleList_text_3_4: 'Estado',
    ei_titleList_text_3_5: 'Cidade',
    ei_titleList_text_3_6: 'Localidade',
    ei_titleList_text_4_1: 'Cônjuge',
    ei_titleList_text_4_2: 'Quantidade de filhos',
    ei_titleList_text_5_1: 'Banco',
    ei_titleList_text_5_2: 'Agência',
    ei_titleList_text_5_3: 'Número de conta',
    ei_complete: 'Completo',
    ei_incomplete: 'Incompleto',
    ei_apply: 'Não Aplica',
    ei_image_not_available: 'Imagem não disponível',
    ei_photo_not_found: 'Imagem não encontrada',
    ei_description:
      '(*) Corresponde a informação fornecida pela área de Recursos Humanos',
    error_50001: 'O nome do template é obrigatório',
    error_50002: 'Houve um erro ao modificar o usuário',
    error_50004: 'Não se encontraram documentos',
    error_50005: 'O nome do template é inválido',
    error_50006: 'Parâmetros incorretos',
    error_00217:
      'Erro na hora de obter o arquivo previamente adicionado durante o onboarding',
    error_50010_1: 'Não foi possível processar o arquivo',
    error_50010_2:
      'O arquivo carregado ultrapassa a quantidade máxima de páginas permitidas',
    error_05006:
      'A data de contratação não pode ser menor à data de nascimento',
    error_05007:
      'Deve existir uma diferença maior a 17 anos entre a data de contratação e a data de nascimento',
    error_05008:
      'Houve um erro reativando o usuário, por favor entre em contato com suporte',
    error_00002: 'Houve um erro na conexão',
    error_00004: 'Não foi possível salvar as alterações',
    error_401: 'usuário e/ou senha incorreta',
    error_00018: 'usuário bloqueado',
    error_04744:
      'Usuário bloqueado por falta de pagamento e/ou falta de ordem de compra, por favor entre em contato com a área de finanças da SICHERN em latam.cobranzas@sichern.com',
    error_50013: 'A URL ingressada não é um vídeo.',
    error_05009: 'A data de alta é inválida.',
    error_05005: 'O funcionário não se encontra em status de inativo.',
    error_05143:
      'A data de alta deve ser maior à data de baixa legal (ver informação no ícone de motivo de baixa)',
    error_05144:
      'A data de baixa não tem um formato de data válido (dd/mm/aaaa)',
    error_05103:
      'A data de alta não tem um formato de data válido (dd/mm/aaaa)',
    error_50044: 'A mensagem de boas-vindas não admite caracteres especiais',
    error_not_onboarding:
      'Usuário em processo de Onboarding, para continuar deve finalizar tal processo em',
    error_rrhh: 'Deve ser de RH para acessar',
    error_20001: 'O modelo de organização deve ser numérico',
    error_20002: 'O modelo de organização enviado não é um valor válido',
    error_20003: 'Não foi possível atualizar o modelo de organização',
    error_20004: 'A integração com Sichern People não está disponível',
    form_select: 'Selecione...',
    title_popover_first_login: 'A senha deve conter:',
    msj_success_title_list: 'Feito',
    msj_success_list: 'O template foi ativado corretamente',
    msj_success_modify_user: 'O usuário foi modificado com sucesso',
    msj_warning_edit: 'Advertência',
    msj_warning_edit_date: 'É necessário preencher "Data de alta" primeiro.',
    msj_success_edit: 'template modificado com sucesso',
    msj_warning_title_list: 'Atenção',
    msj_warning_list: 'O template foi desativado',
    msj_incomplete:
      'Não foi possível salvar as alterações. é obrigatório selecionar, no mínimo, um item das seções "Informação pessoal", "Documentos Pessoais" e "Documentos".',
    msj_typeImg: 'O tipo de imagem deve ser JPG ou PNG',
    msj_sizeImg: 'A imagem deve ser menor de 5 MB',
    head_text_table_list_1: 'Nome',
    head_text_table_list_2: 'Ultima alteração',
    head_text_table_list_3: 'Status',
    head_text_table_search_1: 'Nome e Sobrenome',
    head_text_table_search_2: 'E-mail',
    head_text_table_search_3: 'Documento de identidade',
    head_text_table_search_4: 'Número de registro',
    head_text_table_search_5: 'Status',
    head_text_table_search_6: 'Data de contratação',
    text_table_status_1: 'Ativar',
    text_table_status_2: 'Desativar',
    head_text_document_1: 'Aplica',
    head_text_document_2: 'Imagem',
    head_text_document_3: 'Obrigatório',
    employees_title: 'Gestão de funcionários',
    employees_list_result: 'Lista de funcionários',
    employees_list_search_title_error: 'Isto é um deserto!',
    employees_list_search_desc_error:
      'Sinto muito, mas não encontramos nenhum resultado com os critérios de pesquisa selecionados. Por favor, tente com uma combinação diferente.',
    employees_list_search_title:
      'Os resultados de sua pesquisa aparecerão aqui',
    employees_list_search_desc:
      'Para fazer uma pesquisa você pode preencher o Nome, Sobrenome, Documento de identidade ou E-mail do funcionário no campo de pesquisa ou selecionar uma combinação de filtros.',
    employees_list_modal_folder_title: 'Permissão para pastas',
    employees_list_modal_folder_subtitle: 'Pastas designadas',
    employees_list_modal_folder_empty: 'Não há pastas designadas',
    employees_list_modal_swal_correct: 'Pastas designadas com sucesso',
    employees_list_modal_swal_incorrect:
      'As pastas não se carregaram corretamente, tente novamente',
    employees_list_modal_reset_pass_correct: 'E-mail Enviado',
    employees_list_modal_reset_pass_incorrect: 'Erro ao enviar e-mail',
    employees_list_modal_reset_pass_incorrect_change: 'Erro ao trocar o e-mail',
    search_folder_placeholder: 'Não há mais pastas',
    employees_list_modal_reset_subtitle:
      'Será enviado um link ao usuário para reestabelecer a senha',
    employee_export_results: 'Exportar Resultados',
    employee_exporting_results: 'Exportando...',
    employee_activate_selection: 'Ativar Seleção',
    employee_result: 'Resultados',
    employee_confirm: 'Aceitar',
    employee_edit_error: 'Algo deu errado!',
    employee_edit_success: 'Usuário modificado com sucesso',
    employee_age_validation: 'O funcionário deve ter pelo menos 18 anos',
    employee_alert_selection: 'Lembrete',
    ob_activated_swal_title: 'Bom trabalho!',
    ob_activated_swal_text: 'Os onboarding foram ativados!',
    ob_body: 'Corpo',
    ob_completed: 'Onboarding',
    ob_create_template: 'Novo template',
    ob_documents: 'Documentos',
    ob_load_employees: 'Carga de funcionário',
    ob_masive_load_employees: 'Adicionar funcionários',
    ob_name: 'Nome de Template',
    ob_tooltip_perception:
      'Você pode desabilitar esta pergunta se não quiser que apareça no onboarding',
    ob_not_completed: 'Onboarding',
    ob_not_started: 'Onboarding',
    ob_project: 'OnBoarding',
    ob_info_employee: 'Informação para funcionário',
    ob_search_title: 'Funcionários',
    ob_select: 'Selecione',
    ob_select_template: 'Selecione um template',
    ob_title_model_list: 'Modelo de organização',
    ob_select_model_organization: 'Selecione o modelo de organização',
    ob_submit_swal_confirm: 'Ativar',
    ob_submit_swal_reject: 'Cancelar',
    ob_submit_swal_got_it: 'Entendido',
    ob_submit_swal_text:
      'Após realizada esta operação as alterações não podem ser desfeitas',
    ob_submit_swal_title: 'Deseja dar de alta o funcionário?',
    ob_submit_massive_swal_title:
      'Deseja dar de alta os funcionários selecionados?',
    ob_submit_swal_title_eactivate: 'Deseja dar de alta o funcionário?',
    ob_sujet: 'Assunto',
    ob_started: 'Onboarding',
    ob_template_digital: 'Template Formulário Digital',
    ob_title: 'Configuração de OnBoarding',
    ob_title_list: 'Templates de Onboarding',
    ob_welcome_message: 'Mensagem de Boas-vindas',
    ob_destination_folder:
      'Escolha a localização onde serão armazenados os documentos do funcionário.',
    ob_destination_folder_visible: 'Visível para o funcionário',
    ob_destination_folder_notvisible: 'Não visível para o funcionário',
    ob_move_select_file: 'Arraste ou Selecione um Arquivo',
    ob_destination_folder_warning: 'Deve selecionar uma pasta de destino',
    ob_change_template_tooltip: 'Alterar Modelo On-boarding',
    ob_reactivate_user: 'Reativar funcionário',
    ob_reactivate_user_with_license:
      'Deverá ativar o módulo de licenças manualmente na aba "Configuração" se desejar.',
    ob_reactivate_user_success: 'O funcionário foi reativado com sucesso',
    ob_reactivate_user_date_note:
      'Info: A data deve ser maior à data de baixa legal',
    ob_reactive_user_not_date: 'Necessita preencher data de alta',
    ob_send_notification: 'Enviar lembrete de documentos faltantes',
    ob_send_notification_body:
      'Será enviado um e-mail para os funcionários selecionados em onboarding que tenham documentos obrigatórios pendentes de serem preenchidos',
    ob_send_notification_response: 'Detalhe de envio de lembrete',
    ob_massive_general_error_response:
      'Alguns funcionários não puderam ser ativados corretamente',
    ob_update_user_email: 'Atualizar e-mail',
    ob_update_user_email_subtitle: 'Digite o novo e-mail do colaborador',
    ob_reactive_user_email_exists: 'O e-mail digitado já está sendo usado',
    search_text_select_locacion: 'TODOS',
    search_text_select_sector: 'TODOS',
    search_text_select_centroDeCostos: 'TODOS',
    search_text_select_cargo: 'TODOS',
    search_text_1: 'Pesquisa por:',
    search_text_1_1: 'Documento de identidade, Nome, Sobrenome ou E-mail',
    search_text_1_2: 'Número de registro',
    search_text_1_3: 'Pesquisa Avançada',
    search_text_2: 'Status Funcionário',
    search_text_2_1: 'Onboarding',
    search_text_2_2: 'Ativo',
    search_text_2_3: 'Inativo',
    search_text_3: 'Tipo de Perfil',
    search_text_3_1: 'RH',
    search_text_3_2: 'Funcionário',
    search_text_4: 'Setor',
    search_text_5: 'Locação',
    search_text_6: 'Módulo de Licenças',
    search_text_6_1: 'Aprovador',
    search_text_7: 'Alta',
    search_text_7_1: 'Não ingressaram',
    search_text_8: 'Setor e Locação',
    search_text_9: 'Selecionado',
    search_text_10: 'Data de contratação',
    search_text_11: 'Data de desvinculação',
    search_text_12: 'Centro de custos',
    search_text_date_placeholder: 'Selecione um intervalo de datas',
    search_folder_tooltip: 'Configurar pastas',
    search_reset_pass_tooltip: 'Restabelecer senha',
    checkbox_reset_pass_tooltip: 'Gerar uma senha automaticamente',
    save: 'Salvar Template',
    action_save_template_text: 'Criado com sucesso!',
    edit: 'Editar',
    return: 'Voltar',
    cancel: 'Cancelar',
    search: 'Critérios de pesquisa',
    searchfor: 'Pesquisar',
    home: 'Início',
    menu_1: 'Funcionários',
    menu_2: 'Documentos',
    menu_3: 'Férias e Licenças',
    menu_4: 'Empresa',
    menu_5: 'Relatórios',
    menu_6: 'Configuração OnBoarding',
    menu_7: 'Número de registro digital',
    menu_8: 'Férias e licenças',
    menu_1_1: 'Administrador de funcionários',
    menu_1_2: 'Carga Individual de Funcionário',
    menu_1_3: 'Carga Massiva de Funcionários',
    menu_1_4: 'Lembrete de assinatura',
    menu_1_5: 'Monitor de Atividade',
    menu_1_6: 'Carga Individual de Funcionário',
    menu_1_7: 'Baixa massiva de funcionários',
    menu_2_1: 'Publicação de Documentos',
    menu_2_1_1: 'Publicação Massiva',
    menu_2_1_2: 'Publicação Individual',
    menu_2_1_3: 'Publicação de documentos genéricos',
    menu_2_1_4: 'Gestão de Publicações',
    menu_2_1_5: 'Pesquisador de Documentos',
    menu_2_1_6: 'Status de processos',
    menu_2_2: 'Formulários Digitais',
    menu_2_2_1: 'Fazer Publicação',
    menu_2_2_2: 'Publicações Feitas',
    menu_2_2_3: 'Administração de Formulários Digitais',
    menu_2_2_4: 'Modelos de Formulários Digitais',
    menu_2_3: 'Pesquisador de documentos',
    menu_3_1: 'Gestão de Férias e Licenças',
    menu_3_2: 'Pedidos',
    menu_4_2: 'Painel de notícias',
    menu_4_3: 'Auditoria',
    menu_4_4: 'Configuração',
    menu_4_5: 'Configuração de pastas',
    menu_4_6: 'Centro de segurança',
    menu_4_7: 'Certificados de assinatura eletrônica',
    login_text_or: 'Você também pode',
    login_text_sichern_connect: 'Entrar com Sichern Connect',
    login_text_faq_sichern_connect: 'O que é Sichern Connect?',
    login_text_about_us: 'Sobre nós',
    login_text_button: 'Login',
    login_text_contact: 'Fale conosco',
    login_text_forgot_password: 'Esqueceu sua senha?',
    login_text_language: 'Idioma: ',
    login_text_password: 'Senha',
    login_text_user: 'Usuário',
    login_faq_title: 'Perguntas Frequentes',
    login_faq_one: 'Esqueceu sua senha?',
    login_faq_one_answer:
      "Clicando em 'Esqueceu sua senha?'  deverá indicar seu usuário e um e-mail no qual receberá as indicações para gerar uma nova senha de login. Caso não receba o e-mail, deverá entrar em contato com o departamento de Recursos Humanos de sua empresa, eles poderão assisti-lo.",
    login_faq_two: 'Seu usuário foi bloqueado?',
    login_faq_two_answer:
      'Depois de vários logins malsucedidos para acessar a plataforma, por motivos de segurança, o sistema bloqueará seu usuário. Para desbloqueá-lo deverá digitar o código solicitado e lhe enviaremos um e-mail com instruções para fazer login novamente recuperando sua senha sem precisar modificá-la. Caso não possua um e-mail registrado, deverá entrar em contato com o departamento de Recursos Humanos da sua empresa, quem darão ajuda para restabelecê-la.',
    login_faq_three: 'Informação geral de segurança',
    login_faq_three_answer:
      'A plataforma foi testada com os mais rigorosos métodos de segurança informática e a comunicação se faz de forma encriptada utilizando o registro https, aquele utilizado pelos bancos, cartões de crédito, sites de pagamentos por Internet etc.',
    login_faq_close_button_text: 'Fechar',
    login_need_help: 'Precisa de Ajuda?',
    login_mail:
      'O e-mail informado é utilizado para facilitar a recuperação da senha e a notificação de um novo contracheque. É importante registrar uma conta.',
    login_first_login_title: 'Primeiro acesso',
    login_first_login_subtitle:
      'Por motivos de segurança deve alterar sua senha de login no sistema',
    login_first_login_password_field_label: 'Nova senha',
    login_first_login_repeat_password_field_label: 'Confirme nova senha',
    confirm_password: 'Digite novamente a senha',
    login_first_login_no_email_label: 'Não possuo conta de e-mail',
    login_first_login_email_field_help_text:
      'Lembre digitar um e-mail válido, já que será verificado durante o processo',
    login_first_login_required_field: 'Este campo é requerido',
    login_commercial_info: 'Informação Comercial',
    login_welcome_title:
      'Administre a informação e documentação de sua equipe onde e quando quiser',
    login_welcome_subtitle:
      'Poupe tempo e dinheiro com a Gestão Digital dos Documentos de Recursos Humanos',
    login_send: 'Enviar',
    login_go_back: 'Voltar',
    login_request_password_title: 'Recupero de Senha',
    login_jwt_expired: 'Sua sessão expirou.',
    footer_privacy_policy: 'Políticas de privacidade',
    footer_public_certificate: 'Certificado público de sichern.com',
    product_name: 'Tu Recibo',
    header_top_bar_change_company: 'Trocar de empresa',
    header_top_bar_edit_password: 'Editar senha',
    header_top_bar_edit_email: 'Editar e-mail',
    header_top_bar_logout: 'Sair',
    header_top_bar_modal_save: 'Salvar',
    header_top_bar_new_mail: 'E-mail novo',
    header_top_bar_password_changed_message:
      'Sua senha foi alterada com sucesso.',
    header_top_bar_accept_button_text: 'Aceitar',
    header_top_bar_mail_changed_message: 'Seu e-mail foi alterado com sucesso',
    header_top_bar_change_company_text: 'Trocar de empresa',
    header_top_bar_change_avatar_text: 'Trocar de Avatar',
    home_button_publish: 'Publicar Documentos',
    home_button_main:
      'Aqui vai encontrar os acessos mais frequentes para poder agilizar seu tempo dentro da plataforma.',
    home_button_organizationChart: 'Organograma',
    home_button_add: 'Administrar Funcionários',
    home_create_users: 'Adicionar funcionários',
    home_button_adm_users: 'Administrador de funcionários',
    home_button_search_users: 'Gestão de publicações',
    home_adm_publish: 'Administrador de processos',
    home_button_reports: 'Gestão de relatórios',
    home_welcome_again: 'Bem-vindos',
    home_button_publish_news: 'Publicar notícia',
    switch_user_company_text: 'Empresa',
    switch_user_profile_text: 'Perfil',
    switch_user_status: 'Status',
    switch_user_profile_employee: 'Funcionário',
    switch_user_profile_rrhh: 'Recursos Humanos',
    swal_error: 'Houve um erro!',
    title_404: 'Sinto muito, mas a página não foi encontrada',
    sub_title_404: 'Afortunadamente você pode pesquisar novamente no home',
    btn_text_back_to_home: 'Voltar para o home',
    title_403: 'Sinto muito, mas você não tem acesso a esta página',
    sub_title_403:
      'Se você não for administrador pode ir para o site de funcionário ou voltar para o home',
    yes_logout_text: 'Sim',
    not_logout_text: 'Não',
    headerInfoPersonal: 'Informação pessoal',
    headerDocPers: 'Documentos Pessoais',
    confirm_delete_img_text: 'Tem certeza de que deseja eliminar a imagem?',
    header_logout: 'Aviso',
    downloadDocument: 'Descarregar Documento',
    textNoOnboarding:
      'Este funcionário não passou por um processo de Onboarding',
    error_eForms:
      'Não é possível conectar com o módulo de eForms, aguarde ou entre em contato com o fornecedor',
    header_top_bar_modal_change_button: 'Alterar',
    copyrightText: 'Copyright',
    err_title:
      'Não foi possível salvar as alterações. O nome do template de Onboarding é obrigatório',
    err_infoPersonal:
      'Não foi possível salvar as alterações. É obrigatório selecionar, no mínimo, um item da seção "Informação pessoal" (Grupo familiar é opcional)',
    err_docPersonales:
      'Não foi possível salvar as alterações. É obrigatório selecionar, no mínimo, um item da seção "Documentos Pessoais"',
    err_eF:
      'Não foi possível salvar as alterações. É obrigatório selecionar, no mínimo, um item da seção "Documentos"',
    err_img:
      'Não foi possível salvar as alterações. Você selecionou "Imagem institucional", é obrigatório carregar uma imagem',
    err_video:
      'Não foi possível salvar as alterações. Você selecionou "Vídeo institucional", é obrigatório escrever uma url',
    billboard_form_header_create_title: 'Nova Publicação',
    billboard_form_header_edit_title: 'Editar Publicação',
    billboard_form_content_validator_message:
      'Deve preencher, no mínimo, um conteúdo de texto, imagem ou vídeo',
    billboard_form_submit_button_text: 'Publicar',
    billboard_form_cancel_button_text: 'Cancelar',
    billboard_form_post_preview_text: 'Vista prévia',
    billboard_form_post_details_text: 'Detalhes da publicação',
    billboard_form_post_sectors_text: 'Setores',
    billboard_form_post_locations_text: 'Locações',
    billboard_form_post_recipients_text: 'Destinatários',
    billboard_form_post_input_valid_from_placeholder: 'Válida desde',
    billboard_form_post_input_valid_to_placeholder: 'Válida até',
    billboard_form_post_update_success_text: 'Publicação atualizada.',
    billboard_form_post_button_confirm: 'Aceitar',
    billboard_form_post_error: 'Houve um erro',
    billboard_form_post_create_success_text: 'Publicação feita.',
    billboard_form_dates_validator_message:
      'A data de validade da publicação deve ser maior à data de início',
    billboard_form_textarea: 'Mensagem',
    billboard_form_videos_validator_message:
      'Só serão admitidos vídeos de vimeo ou de Youtube',
    billboard_list_delete_success_message: 'Notificação eliminada.',
    billboard_list_header_title: 'Publicações recentes',
    billboard_list_grid_title_column: 'Título da publicação',
    billboard_list_grid_valid_from_column: 'Válido desde',
    billboard_list_grid_valid_to_column: 'Válido até',
    billboard_list_grid_author_column: 'Autor',
    billboard_list_grid_state_column: 'Status publicação',
    billboard_list_grid_active_state_text: 'Ativa',
    billboard_list_grid_inactive_state_text: 'Inativa',
    billboard_summary_posts_title: 'Publicações',
    billboard_list_delete_confirm_message_title:
      'Tem certeza de que deseja eliminar a notificação?',
    billboard_list_delete_confirm_message_subtitle:
      'Após executada esta operação, não poderá ser desfeita',
    billboard_list_delete_confirm_button_text: 'Sim',
    billboard_list_delete_cancel_button_text: 'Não',
    billboard_create_button_text: 'Nova publicação',
    billboard_page_title: '`Painel de notícias',
    billboard_title_invalid: 'O texto é inválido',
    text_eform_not_found: 'Não foi criado nenhum formulário',
    billboard_modal_preview_title: 'Vista prévia',
    billboard_lazy_loading_text: 'Carregando ...',
    onboarding_empty_1: 'Parece que não existem templates criados',
    onboarding_empty_2:
      'Quando criar um template de onboarding, você poderá configurar os diferentes processos de admissão a serem preenchidos por seus futuros funcionários',
    billboard_loading_text: 'Publicando ...',
    billboard_empty_location_and_sector_text:
      'Deve preencher, no mínimo, uma locação e um setor',
    billboard_forbidden_file_type_text: 'Formato de arquivo não compatível',
    onboarding_label_by_page: 'Mostrar',
    uploadImageComponent: {
      filterBar: {
        formName: 'Nome Formulário',
        filters: 'Filtros',
        form: 'Formulário',
        selfService: 'Autogestão',
        status: 'Status',
        active: 'Ativo',
        inactive: 'Inativo',
        packages: 'Pacotes de envios',
        select: 'Selecione...'
      },
      header: {
        titleHeader: 'Painel de tarefas',
        subtitleHeader1: 'Início'
      },
      topBar: {
        approveButton: 'Aprovar',
        rejectButton: 'Rejeitar'
      },
      modals: {
        fileUploadVisualizerTitle: 'Visualização de documento',
        individualErrorModalTitle: 'Problema na hora de processar o documento',
        individualRejectModalTitle: 'Motivo da rejeição',
        individualRejectWarning: 'Você vai rejeitar este documento',
        individualRejectWarning2: 'Esta ação não pode ser desfeita',
        individualRejectPlaceholderTextArea:
          'Preencha o motivo de rejeição do documento',
        individualRejectSuccessfulModalTitle: 'Documento rejeitado',
        individualRejectDocumentRejected: 'Documento rejeitado',
        individualRejectInfo: 'Você rejeitou o ',
        multipleRejectWarning: 'Você vai rejeitar {input} documentos',
        multipleRejectPlaceholderTextArea:
          'Preencha o motivo de rejeição dos documentos',
        multipleApproveModalTitle: 'Aprovar selecionados',
        multipleApproveConfirm:
          'Tem certeza de querer <strong>Aprovar</strong> os <strong>{input} elementos selecionados</strong> de seu painel de tarefas?',
        multipleApproveWarning: 'Esta ação não pode ser desfeita',
        multipleRejectDocumentRejected: 'Documentos rejeitados',
        buttonApprove: 'Aprovar',
        buttonApproveLoading: 'Aprovando...',
        buttonReject: 'Rejeitar',
        buttonRejectLoading: 'Rejeitando...',
        buttonCancel: 'Cancelar',
        individualError:
          'Houve um erro na hora de processar o documento, por favor tente novamente',
        pleaseWait: 'Caso o problema persista, aguarde uns minutos',
        buttonUnderstand: 'Entendido',
        multipleApproveSuccess: 'Documentos aprovados',
        xDocumentsApproved: '{quantity} Registros aprovados',
        handledErrorsModalTitle: 'Problema na hora de processar o documento',
        handledErrorsMessage:
          'Houve um erro com os seguintes {quantity} documentos de sua seleção',
        buttonRetry: 'Tentar novamente',
        buttonRetryLoading: 'Tentando novamente...'
      },
      body: {
        noPendingTasks: {
          title: 'Não há documentos em seu painel de tarefas',
          content: 'Relaxe e curta o momento'
        },
        leftContainer: {
          filter: {
            searchFilter: 'Filtros de pesquisa',
            filterButton: 'Filtros',
            searchLabel: 'Pesquisar',
            inputPlaceholder:
              'Nome, sobrenome, identificador único, data, setor e locação',
            inputBaseMessage:
              'Procurar por Nome, Sobrenome, Identificador único',
            SelectOption: 'Ordenar por:',
            allFiltersOn: 'Todos',
            date: 'Data',
            documentType: 'Tipo de documento',
            name: 'Nome',
            cuil: 'CPF',
            sector: 'Setor',
            time: 'Hora',
            orderBy: 'Ordenado por:',
            locacion: 'Locação',
            document: 'Tipo de documento',
            asc: 'Ascendente',
            desc: 'Descendente'
          },
          multipleSelection: {
            oneSelectedItem: '1 selecionado',
            xSelectedItems: '{quantity} selecionados',
            selectAll: 'Selecionar os outros {total} registros'
          },
          singleApprove: {
            questionApprove: 'Tem certeza de que deseja aprovar o documento?',
            singleApproveSuccess: 'O documento foi aprovado',
            singleApproveError: 'Houve um erro na hora de aprovar o documento'
          },
          singleDeny: {
            denySingle: 'Rejeição de documento',
            questionDeny: 'Tem certeza de que deseja rejeitar o documento?',
            singleDenySuccess: 'O documento foi rejeitado',
            singleDenyError: 'Houve um erro na hora de rejeitar o documento'
          },
          massiveApprove: {
            buttonApproveAll: 'Aprovação Massiva',
            questionMassiveApprove:
              'Tem certeza de que deseja aprovar massivamente os documentos selecionados?',
            massiveApproveSuccess: 'Os documentos foram aprovados',
            massiveApproveError:
              'houve um erro na hora de aprovar massivamente os documentos'
          },
          massiveDeny: {
            buttonDenyAll: 'Rejeição Massiva',
            denyAll: 'Rejeição Massiva de documentos',
            denyAllText:
              'A rejeição do documento envia um e-mail notificando ao funcionário.',
            denyAllPlaceholder: 'Descreva o motivo de rejeição',
            questionMassiveDeny:
              'Tem certeza de que deseja rejeitar massivamente os documentos selecionados?',
            massiveDenySuccess: 'Os documentos foram rejeitados',
            massiveDenyError:
              'Houve um erro na hora de rejeitar massivamente os documentos'
          },
          generalErrors: {
            errorOnSubmit: 'Houve um erro',
            errorOnLoadCards:
              'Houve um erro na hora de mostrar as cargas pendentes dos usuários'
          },
          noMoreResults: 'Não há mais resultados',
          noMoreSearchingFromUser:
            'Não há tarefas que coincidam com sua pesquisa'
        },
        rightContainer: {
          noContentEmptyState: {
            title: 'Aqui serão visualizados os tipos de documentos',
            content:
              'Você pode escolher vários documentos e aprová-los ou rejeitá-los massivamente'
          },
          employeeInfo: {
            attaches: 'Anexos',
            dontHaveIt: 'Não tem',
            pages: 'Página'
          },
          image: {
            problemWithImage:
              'Houve um problema na hora de cargar a imagem, por favor consulte com suporte',
            page: 'Página',
            loading: 'Carregando documento'
          },
          multipleSelection: 'Múltipla seleção de documentos'
        },
        noContentEmployeeInfo: {
          noSector: 'Não possui setor',
          noLocacion: 'Não possui locação',
          noCuil: 'Não possui CPF',
          noArchiveName: 'Sem nome de carga',
          noDate: 'Não possui data'
        },
        swalButtons: {
          cancel: 'Não',
          accept: 'Aceitar',
          approve: 'Sim',
          deny: 'Sim'
        }
      },
      errorLogs: {
        '04002':
          'O funcionário não pertence à empresa do usuário que carregou o documento',
        '04003': 'Formato inválido',
        '04004': 'O PDF não pode ultrapassar o total de páginas permitidas',
        '04005': 'Erro na hora de carregar o arquivo',
        '04006': 'O campo nome é requerido',
        '04007': 'O campo template é requerido',
        '04008': 'Você não é administrador',
        '04009': 'O campo nome é requerido',
        '04010': 'O campo Json é requerido',
        '04011': 'Não foi possível obter o usuário',
        '04012': 'Você não possui permissão para executar esta ação',
        '04013': 'O parâmetro Id_type_document é requerido',
        '04014': 'O parâmetro Template é requerido',
        '04015': 'O parâmetro Files é requerido',
        '04016': 'O usuário não possui o action profile requerido',
        '04018': 'A quantidade de arquivos carregados é incorreta',
        '04019': 'O campo de valor é requerido',
        '04020': 'O Id_type_documen não pertence à empresa',
        '04021': 'Formato do Json invalido',
        '04022': 'Devem ser adicionados parâmetros junto ao Json',
        '04023': 'Os parâmetros dentro do Json são incorretos',
        '04024':
          'O funcionário não pertence ao sector do usuário que carregou o documento',
        '04025':
          'O funcionário não pertence à locação do usuário que carregou o documento',
        '04026': 'O documento deve estar em status inicial',
        '04027': 'O status foi alterado com sucesso',
        '04028': 'Erro na hora de atualizar a base de dados',
        '04029': 'O status foi alterado com sucesso',
        '04030': 'O parâmetro País não é correto',
        '04031': 'O parâmetro empresa não é correto',
        '04032': 'O ID da empresa deve ser numérico',
        '04033': 'O ID do país deve ser numérico',
        '04034': 'O ID é requerido',
        '04035': 'O nome é requerido',
        '04036': 'O formato do arquivo é incorreto',
        '04037': 'O ID é incorreto',
        '04038': 'O ID não pertence à carga do usuário',
        '04039': 'A carga do arquivo foi malsucedida',
        '04040': 'Nome incorreto.',
        '04041': 'Erro na hora de atualizar o template',
        '04042': 'Já foi completada a carga máxima de arquivos',
        '04043': 'Você não pode ver documentos de outras empresas',
        '04044': 'O campo hash é requerido',
        '04045': 'Os hash não coincidem',
        '04046': 'Não foi possível criar o diretório corretamente',
        '04047': 'O documento não existe',
        '04048': 'Erro na hora de unir arquivos',
        '04049': 'O arquivo ultrapassa o tamanho máximo',
        '04051': 'Não é possível ler o arquivo PDF',
        '05000': 'Desconhecido',
        '05101': 'Licenças progressivas não tem um valor válido',
        '05102': 'A fecha de nascimento não tem uma data válida',
        '05103': 'A data de contratação não tem uma data válida',
        '05104': 'A data de contratação não tem uma data válida',
        '05105': 'O número de registro não é um número inteiro válido',
        '05106':
          'Níveis de aprovação de licenças progressivas não tem uma data válida',
        '05107':
          'O número de registro de aprovador não é um número inteiro válido',
        '05108':
          'A antiguidade prévia de licenças progressivas não é um número inteiro válido',
        '05109':
          'O ID de políticas de licenças progressivas não é um número inteiro válido',
        '05110': 'O ID da empresa é requerido',
        '05111': 'O usuário é requerido',
        '05112': 'O nome é requerido',
        '05113': 'O sobrenome é requerido',
        '05114': 'O Documento de Identidade é requerido',
        '05115': 'O CPF é requerido',
        '05116': 'O nome deve conter entre 1 e 50 caracteres alfanuméricos',
        '05117':
          'O sobrenome deve conter entre 1 e 50 caracteres alfanuméricos',
        '05118': 'O e-mail não tem um formato válido',
        '05119':
          'O usuário deve conter entre 1 e 32 caracteres alfanuméricos, incluídos caracteres alfanuméricos, dígitos e underline',
        '05120':
          'O documento de identidade deve conter entre 5 e 15 caracteres alfanuméricos, os caracteres alfanuméricos devem estar em maiúsculas',
        '05121':
          'O CPF deve conter entre 5 e 15 caracteres alfanuméricos, os caracteres alfanuméricos devem estar em maiúsculas',
        '05122':
          'O setor deve ser alfanumérico e pode incluir barras, espaços, vírgulas e o símbolo "+". Não deve ultrapassar os 250 caracteres.',
        '05123':
          'A locação deve ser alfanumérica e pode incluir barras, espaços, vírgulas e o símbolo "+". Não deve ultrapassar os 250 caracteres.',
        '05124': 'O usuário é duplicado',
        '05125': 'O e-mail é duplicado',
        '05126': 'O documento de identidade é duplicado',
        '05127': 'O CPF é duplicado',
        '05128': 'A data de nascimento não pode ser uma data posterior a hoje',
        '05129': 'A data de nascimento denota um funcionário menor de idade',
        '05130':
          'A data de contratação não deve ultrapassar os 40 dias a partir de hoje',
        '05131': 'A data de nascimento deve ser superior à data de contratação',
        '05132':
          'Deve ter uma diferença de 14 anos entre a data de nascimento e a data de contratação',
        '05133': 'O número de registro é duplicado',
        '05134': 'A senha ou o e-mail são requeridos',
        '05135': 'A senha deve ter, no mínimo, 8 caracteres',
        '05136': 'Pular o e-mail de boas-vindas não tem um valor válido',
        '05137':
          'A alteração no valor pode desvincular as publicações de documentos do usuário',
        '05138':
          'A alteração no valor pode invalidar a senha, deve ser resetada',
        '05139': 'A data de contratação é obrigatória e não pode ser alterada',
        '05140':
          'Não foi possível atualizar o número de registro já que é aprovador de um outro funcionário.',
        '05141': 'A data de contratação do usuário é requerida'
      },
      fileUploadLicenses: {
        title: 'Novidades no módulo de Férias e licenças',
        description:
          'A partir de agora os colaboradores vão poder anexar arquivos nos seus pedidos de licenças.',
        knowMore: 'Saiba mais',
        benefits: {
          title: 'Alguns benefícios desta nova funcionalidade:',
          list: [
            'Os colaboradores poderão carregar documentação de apoio com um passo simples na hora de fazer a solicitação',
            'Os aprovadores poderão consultar e descarregar a documentação para tomar melhores decisões',
            'A carga obrigatória ou optativa é configurável'
          ]
        },
        howToActivate: {
          title: 'Como ativá-la?',
          description: 'Entre em contato com',
          support: 'Suporte técnico'
        }
      },
      maintenance: {
        title: 'Manutenção de plataforma',
        understood: 'Entendido'
      },
      digitalFile: {
        title: 'Temos um novo módulo para você',
        description: 'Olá {name}. Está disponível o módulo: Registro Digital.',
        close: 'Fechar'
      },
      sichernCommunity: {
        enter: 'Acessar',
        later: 'Em outro momento'
      },
      taskWidget: {
        documents: 'Documentos',
        toReview: 'a serem verificados',
        goToInbox: 'Ir para painel de tarefas'
      },
      employeeStatus: {
        title: 'Funcionários Ativos',
        onboardingTitle: 'Funcionários Onboarding'
      },
      leftMenu: {
        knowMore: 'Saiba mais',
        taskInbox: 'Painel de Tarefas',
        userManual: 'Manual de usuário'
      },
      onboarding: {
        subject: 'Assunto'
      },
      detailEform: {
        status: 'Status',
        active: 'Ativo',
        inactive: 'Inativo',
        packages: 'Pacotes de envio:',
        selfService: 'Autogestão',
        selfServiceDescription:
          'Quando ativar a autogestão, o formulário estará disponível na plataforma para os colaboradores o preencherem e enviarem para a área de Recursos Humanos quando for necessário.',
        destinationFolder: 'Pasta destino',
        folderError: '* Escolha uma pasta válida para guardar o documento',
        requiresApproval: 'Precisa de aprovação de RH',
        isCertificate: 'É um certificado',
        certificateDescription:
          'Quando ativar o formulário como certificado, estarão disponíveis na plataforma dos colaboradores para serem descarregados de forma automática.',
        save: 'Salvar',
        saving: 'Salvando...',
        successMessage: 'Documento digital alterado'
      }
    },
    text_mask_character: '(máximo 140 caracteres)',
    crossSelling: {
      digitalFile: {
        landing: {
          title: 'O que você pode fazer em registro digital?',
          item_1: 'Ter uma experiencia de OnBoarding 100% digital',
          item_2: 'Preencher e assinar todos os documentos de alta',
          item_3: 'Apresentar toda a documentação requerida em formato digital',
          item_4: 'Conhecer sua equipe de trabalho',
          item_5: 'Ter as respostas para suas perguntas frequentes',
          buttonDefault: 'Preciso de maiores informações',
          buttonSent: 'Solicitação enviada'
        },
        toaster: {
          title: 'Registro Digital informação',
          containerText:
            'Olá {nome}! Muito obrigado por entrar em contato conosco. Um assessor comercial entrará em contato com você dentro das próximas 24-48hs para fornecer a informação solicitada.',
          button: 'Entendido'
        }
      },
      licenses: {
        landing: {
          title: 'O que você pode fazer em Férias & Licenças?',
          item_1:
            'Os funcionários vão poder solicitar via mobile ou desktop férias e licenças',
          item_2: 'Você vai poder aprovar ou rejeitar solicitações pendentes',
          item_3:
            'Você terá um completo relatório de saldos e pesquisador de solicitações passadas',
          item_4: 'Fluxo de aprovadores por níveis',
          item_5: 'Adaptável aos convênios e regulamentações do seu país',
          buttonDefault: 'Preciso de maiores informações',
          buttonSent: 'Solicitação enviada'
        },
        toaster: {
          title: 'Férias e licenças informação',
          containerText:
            'Olá {nome}! Muito obrigado por entrar em contato conosco. Um assessor comercial entrará em contato com você dentro das próximas 24-48hs para fornecer a informação solicitada.',
          button: 'Entendido'
        }
      }
    },
    documentSearch: {
      searchTitlePreview: 'Vista prévia do documento',
      searchDownloadText: 'Descarregando...',
      previewNotFound: {
        title: 'Documento não disponível',
        message: 'O documento não está disponível no momento. Por favor, entre em contato com a equipe de suporte.'
      },
      donwload: {
        searchToExcel: 'Resultados a folha de cálculo',
        eformsData: 'Dados de formulários digitais',
        observations: 'Observações sobre documentos',
        undoSelection: 'Anular Seleção',
        popup: {
          eformsData: {
            header: 'Descarregar dados de formulários digitais',
            body_a:
              'A seguir aparecerão todos os formulários encontrados dentro do resultado da pesquisa.',
            body_b:
              'Quando descarregar os dados, eles aparecerão em formato de folha de cálculo',
            column_name: 'Nome Template',
            column_action: 'Descarregar dados'
          },
          observations: {
            header: 'Descarregar observações sobre documentos',
            empty:
              'Os documentos mostrados não apresentam observações registradas.'
          }
        }
      }
    },
    profileModals: {
      switchCompany: {
        current: 'Atual',
        profile: 'Perfil',
        myCompanies: 'Minhas empresas',
        change: 'Trocar',
        ipRestricted: 'Restringido por IP',
        blockedCompany:
          'Empresa bloqueada por motivos administrativos. Por favor, entre em contato com a área de Finanças da SICHERN em latam.cobranzas@sichern.com'
      },
      editPass: {
        title: 'Altere sua senha de acesso',
        currentPass: 'Digite a senha atual',
        newPass: 'Digite uma nova senha',
        repeatPass: 'Repita a nova senha',
        notSamePass: 'As senhas não coincidem'
      },
      editMail: {
        title: 'Altere seu e-mail pessoal',
        currentMail: 'Seu e-mail atual associado é',
        inputsTitle: 'Digite um novo e-mail e sua senha atual',
        newMail: 'E-mail novo',
        password: 'Senha atual'
      },
      save: 'Salvar',
      cancel: 'Cancelar'
    },
    sichernIntegrations: {
      sichernPeople: {
        errors: {
          SICHERN_PEOPLE_PUT_APPROVE_ABSENCE_NOT_FOUND:
            'Não foi possível encontrar a licença em Sichern People, entre com contato com o seu administrador.',
          SICHERN_PEOPLE_PUT_APPROVE_ABSENCE_ERROR:
            'Não foi possível processar o pedido neste momento, tente mais tarde.',
          SICHERN_PEOPLE_PUT_APPROVE_ABSENCE_BAD_REQUEST:
            'Houve um problema na hora de processar o pedido',
          SICHERN_PEOPLE_PUT_APPROVE_ABSENCE_BAD_REQUEST_StatusNotAllowed:
            'A licença já foi processada'
        }
      },
      sichernCommunityWidget: {
        title: 'Últimas Novidades',
        noContent: 'Não há novidades',
        viewMore: 'Veja mais novidades'
      },
      homeDashboard: {
        title: 'Novidades nos nossos produtos',
        info: 'Acesse em <b>Sichern Community</b> e descubra toda a informação do software, HR e muito mais.',
        confirm_btn: 'Ir para Sichern Community'
      },
      activateOnboarding: {
        ob_massive_download_csv:
          'Descarregue a lista de erros para identificar os funcionários afetados',
        dowload_btn: 'Descarregar',
        cancel_btn: 'Cancelar',
        errorIE:
          'Esta funcionalidade não é suportada em IE, por favor utilize um outro navegador',
        errors: {
          generic:
            'Não foi possível criar o usuário em Sichern People. Tente novamente em alguns minutos',
          InvalidDocumentIdentifier:
            'O formato do número de documento de identidade é incorreto',
          EmployeeFoundWithSameDocumentAndSameFileNumber:
            'Foi encontrado um Funcionário com o mesmo tipo e número de Documento',
          FileNumberExists:
            'O Número de registro está duplicado em VP, verifique os dados',
          EmployeeNotFoundWithFileNumberAndDocumentNumber:
            'O número de registro enviado não coincide com os dados em VP, revisar os dados',
          EmployeeNotFound:
            'O RG, CPF ou Número de registro do usuário não coincide com a informação existente em Sichern People, por favor verifique a informação e atualize o que for preciso.'
        },
        success: {
          title: 'Funcionário ativado com observações',
          info: 'Foi criado o usuário em Sichern People, mas com erros em algum de seus campos. Você pode terminar de preencher a informação em Sichern People.'
        },
        validations: {
          modal_title: 'Os seguintes campos são obrigatórios',
          modal_subtitle:
            'Não será possível ativar o Funcionário até ele não preencher a seguinte informação',
          VP_FIRSTNAME_IS_REQUIRED: 'Nome',
          VP_LASTNAME_IS_REQUIRED: 'Sobrenome',
          VP_NATIONALITY_IS_REQUIRED: 'Nacionalidade',
          VP_GENRE_IS_REQUIRED: 'Gênero',
          VP_BIRTHDATE_IS_REQUIRED: 'Data de nascimento',
          VP_BIRTHDATE_IS_INVALID: 'Data de nascimento é inválida',
          VP_CIVIL_STATUS_IS_REQUIRED: 'Estado civil',
          VP_DNI_IS_REQUIRED: 'RG',
          VP_DNI_IS_DUPLICATED:
            'Detectamos que o número de documento do usuário se encontra duplicado em Sichern People',
          VP_CUIL_IS_REQUIRED: 'CPF',
          VP_ADDRESS_TYPE_IS_REQUIRED: 'Tipo de endereço',
          VP_STREET_NAME_IS_REQUIRED: 'Rua',
          VP_STREET_NUMBER_IS_REQUIRED: 'Número',
          VP_ADDRESS_FLOOR_IS_REQUIRED: 'Andar',
          VP_ADDRESS_DEPARTMENT_NUMBER_IS_REQUIRED: 'Apartamento',
          VP_ZIPCODE_IS_REQUIRED: 'CEP',
          VP_LOCALITY_IS_REQUIRED: 'Localidade/Cidade',
          VP_PROVINCE_IS_REQUIRED: 'Estado',
          VP_COUNTRY_IS_REQUIRED: 'País',
          VP_ORGANIZATION_MODEL_IS_REQUIRED: 'Modelo de organização',
          VP_HIREDATE_IS_REQUIRED: 'Data de alta/contratação'
        },
        massive_validations: {
          VP_FIRSTNAME_IS_REQUIRED: 'Nome é requerido',
          VP_LASTNAME_IS_REQUIRED: 'Sobrenome é requerido',
          VP_NATIONALITY_IS_REQUIRED: 'Nacionalidade é requerido',
          VP_GENRE_IS_REQUIRED: 'Gênero é requerido',
          VP_BIRTHDATE_IS_REQUIRED: 'Data de nascimento é requerido',
          VP_BIRTHDATE_IS_INVALID: 'Data de nascimento é inválida',
          VP_CIVIL_STATUS_IS_REQUIRED: 'Estado civil é requerido',
          VP_DNI_IS_REQUIRED: 'RG é requerido',
          VP_DNI_IS_DUPLICATED:
            'Detectamos que o número de documento do usuário se encontra duplicado em Sichern People',
          VP_CUIL_IS_REQUIRED: 'CPF é requerido',
          VP_ADDRESS_TYPE_IS_REQUIRED: 'Tipo de endereço é requerido',
          VP_STREET_NAME_IS_REQUIRED: 'Rua é requerido',
          VP_STREET_NUMBER_IS_REQUIRED: 'Número é requerido',
          VP_ADDRESS_FLOOR_IS_REQUIRED: 'Andar é requerido',
          VP_ADDRESS_DEPARTMENT_NUMBER_IS_REQUIRED: 'Apartamento é requerido',
          VP_ZIPCODE_IS_REQUIRED: 'CEP é requerido',
          VP_LOCALITY_IS_REQUIRED: 'Localidade/Cidade é requerido',
          VP_PROVINCE_IS_REQUIRED: 'Estado é requerido',
          VP_COUNTRY_IS_REQUIRED: 'País é requerido',
          VP_ORGANIZATION_MODEL_IS_REQUIRED:
            'Modelo de organização é requerido',
          VP_HIREDATE_IS_REQUIRED: 'Data de alta/contratação é requerido',
          SICHERN_PEOPLE_MEDIATOR:
            'Não foi possível criar o usuário em Sichern People. Tente novamente em alguns minutos',
          SICHERN_PEOPLE_INVALID_POST_VALUES_MEDIATOR:
            'Não foi possível criar o usuário em Sichern People. Tente novamente e alguns minutos',
          EXTERNAL_API_COULD_NOT_CONNECT:
            'Não foi possível criar o usuário em Sichern People. Tente novamente e alguns minutos',
          SICHERN_PEOPLE_ADDITIONAL_DATA:
            'Foi criado o usuário em Sichern People, mas com erros em algum dos seus campos. Você pode terminar de preencher a informação dentro de Sichern People.',
          SICHERN_PEOPLE_POST_MEDIATOR_BAD_REQUEST: {
            InvalidDocumentIdentifier:
              'O formato do número de documento de identidade é incorreto',
            EmployeeFoundWithSameDocumentAndSameFileNumber:
              'Foi encontrado um Funcionário com o mesmo tipo e número de Documento',
            FileNumberExists:
              'O Número de registro está duplicado em VP, verifique os dados'
          },
          SICHERN_PEOPLE_PUT_MEDIATOR_BAD_REQUEST: {
            InvalidDocumentIdentifier:
              'O formato do número de documento de identidade é incorreto',
            EmployeeNotFoundWithFileNumberAndDocumentNumber:
              'O número de registro enviado não coincide com os dados em VP, verifique os dados',
            EmployeeNotFound:
              'O RG, CPF ou Número de registro do usuário não coincide com a informação existente em Sichern People, por favor verifique a informação e atualize o que for necessário.'
          },
          PERFORMANCE_CONFIGURATION_ERROR: 'Erro de configuração do sistema',
          PERFORMANCE_VALIDATION: 'Dados incompletos (ID, RG ou Template faltante)',
          PERFORMANCE_AUTHENTICATION_ERROR: 'Erro de autenticação com Performance',
          PERFORMANCE_SEND_DATA_ERROR: 'Performance rejeitou os dados enviados',
          PERFORMANCE_UNEXPECTED_ERROR: 'Serviço Performance temporariamente indisponível'
        }
      }
    },
    performanceIntegrations: {
      activateOnboarding: {
        errors: {
          generic: 'Não foi possível criar o usuário em Performance. Tente novamente em alguns minutos',
          PERFORMANCE_CONFIGURATION_ERROR: {
            title: 'Erro',
            description: 'Erro na configuração do sistema. Contate o suporte para receber ajuda.'
          },
          PERFORMANCE_VALIDATION: {
            title: 'Os seguintes campos são obrigatórios',
            description: 'Não será possível ativar o funcionário até que ele complete a seguinte informação:',
            fields: 'Campos obrigatórios'
          },
          PERFORMANCE_AUTHENTICATION_ERROR: {
            title: 'Erro',
            description: 'Erro de Autenticação. Contate o suporte para receber ajuda.'
          },
          PERFORMANCE_SEND_DATA_ERROR: {
            title: 'Erro',
            description: 'Os dados do colaborador não estão corretos. Formato inválido ou Colaborador inexistente. Revise os dados de identificação do colaborador.'
          },
          PERFORMANCE_UNEXPECTED_ERROR: {
            title: 'Erro',
            description: 'Serviço Temporariamente Indisponível. Tente novamente em alguns minutos.'
          }
        }
      }
    },
     rexIntegrations:{
      errors: {
        default_error:'Serviço temporariamente indisponível. Tente novamente em alguns minutos',
        REX_UNEXPECTED_ERROR:'Serviço temporariamente indisponível. Tente novamente em alguns minutos',
        EXTERNAL_API_REX_REQUEST_ERROR: 'Erro na API do Rex'

      }
    },
    main_document_page: {
      document: {
        title_document: 'Documentos',
        search_document: 'Pesquisador de Documentos',
        subtitle_search_document:
          'Pesquisa de documentos no registro dos seus colaboradores',
        publish: 'Publicação em massa',
        subtitle_publish: 'Enviar documentos em massa aos colaboradores'
      },
      publish: {
        title_publish: 'Publicação',
        individual: 'Publicação Individual',
        subtitle_individual: 'Enviar um documento para um colaborador',
        generic: 'Publicação genérica',
        subtitle_generic:
          'Enviar um mesmo documento massivamente para mais de um colaborador',
        signature_reminder: 'Lembrete de assinatura',
        title_signature_reminder:
          'Enviar lembrete de assinatura sobre os documentos pendentes'
      },
      forms: {
        title_publish: 'Formulários',
        publish_forms: 'Publicar Formulários',
        subtitle_publish_forms: 'Enviar formulários para os seus colaboradores',
        published_forms: 'Formulários publicados',
        subtitle_published_forms:
          'Consultas sobre os formulários enviados para os seus colaboradores',
        config_forms: 'Configuração de formulários',
        subtitle_config_forms: 'Criar ou modificar os formulários'
      },
      management: {
        title_management: 'Gestão',
        publish_title_management: 'Gestão de publicação',
        subtitle_publish_title_management:
          'Modificar status de publicações feitas',
        process_status: 'Status de processos',
        subtitle_process_status: 'Veja o status das publicações feitas'
      }
    },
    publishDocuments: {
      title: 'Publicação de documentos',
      goBack: 'Voltar',
      loaderTxt: 'Carregando vista prévia...',
      configMassivePublish: {
        title: 'Publicação massiva de documentos',
        companyAlert: 'A publicação vai ser feita na empresa ',
        monthTitle: 'A que mês corresponde o documento?',
        monthContent:
          'Selecione o mês ao qual pertence o documento que vai disponibilizar para os seus colaboradores. Disponível 1 mês para frente e até 12 meses para trás',
        monthSelect: 'Selecione o mês',
        documentTypeTitle: 'Qual documento vai enviar para o seu colaborador?',
        documentTypeContent:
          'Selecione dentre os diferentes tipos de documentos carregados no sistema para publicar',
        documentTypeSelect: 'Título de documento',
        documentProcessTitle:
          'É necessário executar algum processo nos documentos?',
        documentProcessContent:
          'O documento final que vai receber o seu colaborador precisa de algum processo como serem divisão de pdf, rotação e assinatura dos documentos',
        documentProcessNone:
          'Tenho os documentos prontos para serem publicados',
        documentProcessNoneContent:
          'Os documentos já foram divididos e assinados externamente',
        documentProcessSplitSign: 'Necessito dividi-los e assiná-los',
        documentProcessSplitSignContent:
          'Vamos fazer a divisão e aplicar a assinatura da empresa nos documentos',
        documentProcessSplit: 'Necessito dividi-los',
        documentProcessSplitContent:
          'Vamos dividir os documentos, posteriormente você vai poder descarregar um arquivo comprimido para assiná-lo externamente',
        documentProcessOnlySign: 'Necessito assiná-los',
        documentProcessOnlySignContent:
          ' Os documentos já foram divididos externamente, vamos aplicar a assinatura da empresa na plataforma',
        sendEmailTitle:
          'Você quer receber os resultados da publicação por e-mail?',
        sendEmailContent:
          'Após feita a publicação, vai receber no seu e-mail cadastrado um resumo com os resultados da publicação',
        email: 'E-mail',
        sendEmailCollabTitle: 'Você quer notificar aos seus colaboradores?',
        sendEmailCollabContent:
          'Seus colaboradores vão receber um e-mail com a notificação de que têm uma nova publicação para ser revisada',
        sendEmailCollabContentPush:
          'Se escolher a notificação PUSH, o Funcionário vai receber um aviso no seu celular caso tenha o aplicativo instalado e se concedeu a permissão para ser notificado.',
        sendEmailCollabYes: 'Sim, notificar colaboradores',
        sendEmailCollabNo: 'Não',
        sendPushCollab: 'Incluir notificação push',
        btnNext: 'Seguinte',
        btnCancel: 'Cancelar',
        badgeNews: 'Proximamente',
        publish: 'Publicar',
        signAndPublish: 'Assinar e publicar',
        hasCertEnabled:
          'Você não tem un certificado para assinar os documentos eletronicamente',
        noPermissionCert:
          'Você não tem um certificado vigente para assinar os documentos eletronicamente.',
        emailCertEmptyRecipients:
          'Não há um usuário definido com certificado ativo para assinar os documentos eletronicamente, por favor entre em contato com suporte.',
        noEmail:
          'O usuário com permissão para criar certificados não possui um e-mail associado no sistema.',
        hasFnParser:
          'Este documento tem um processo de captura que não admite o processo de corte e assinatura',
        noSignPosition:
          'Você não tem definido o posicionamento da assinatura do Funcionário',
        createCert: 'Criar certificado',
        contactAdmin: 'Entre em contato com o administrador',
        configSignPosition: 'Configurar assinatura do Funcionário',
        sending: 'Enviando...',
        messageSent: 'Mensagem enviada',
        enterEmail: 'Digitar e-mail',
        hasSignRequired: 'Este documento precisa de assinatura.',
        noSignRequired: 'Este documento não precisa de assinatura.'
      },
      onlyPublish: {
        title: 'Carga de arquivo',
        subtitle: 'Selecione um arquivo a ser processado',
        description:
          'O arquivo que vai carregar na plataforma tem que ser o arquivo .zip pronto para ser publicado (já cortado e assinado de forma externa).',
        label: 'Selecione seu arquivo',
        uploadingFile: 'Carregando arquivo',
        fileSizeExceded: 'O arquivo não pode ultrapassar os 750 MB',
        wrongFiletype: 'O arquivo deve ter extensão .zip',
        success: '<strong>{quantity}</strong> Documentos processados',
        addEmail:
          'O usuário <b>{userName}</b> é o responsável de gerar o certificado. <br /><br /> Você quer adicionar o seu e-mail para ser notificado?',
        haveNoEmail:
          'Não tenho o e-mail, vou utilizar um outro meio de contato',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
        enterEmail: 'Digite o e-mail',
        sizeKb: '1 Arquivo ({size} KB no total)',
        sizeMb: '1 Arquivo ({size} MB no total)',
        modal: {
          title: 'Publicação de documentos',
          title_container: 'Tem certeza de que quer publicar os documentos?',
          description:
            'Os documentos vão ser disponibilizados para os seus colaboradores',
          cancel: 'Cancelar',
          confirm: 'Sim, publicar'
        },

        modalCancel: {
          title: 'Eliminar documento',
          description: 'Tem certeza de querer eliminar o documento?',
          cancel: 'Cancelar',
          confirm: 'Sim, eliminar'
        }
      },
      onlySign: {
        title: 'Carga de arquivo',
        subtitle: 'Selecione um arquivo para ser processado',
        description:
          'O arquivo que vai carregar na plataforma tem que ser o arquivo .zip com os documentos divididos externamente, vamos aplicar a assinatura para você poder publicá-lo',
        label: 'Selecione o seu arquivo',
        uploadingFile: 'Carregando arquivo',
        fileSizeExceded: 'O arquivo não pode ultrapassar os 750 MB',
        wrongFiletype: 'O arquivo deve ter extensão .zip',
        success: '<strong>{quantity}</strong> Documentos processados',
        modal: {
          title: 'Publicação de documentos',
          title_container: 'Tem certeza de que quer publicar os documentos?',
          description:
            'Os documentos vão ser disponibilizados para os seus colaboradores',
          cancel: 'Cancelar',
          confirm: 'Sim, publicar'
        },

        modalCancel: {
          title: 'Eliminar documento',
          description: 'Tem certeza de que quer eliminar o documento?',
          cancel: 'Cancelar',
          confirm: 'Sim, eliminar'
        },
        modalPreviewDocument: {
          title: 'Vista prévia',
          buttonClose: 'Fechar vista prévia',
          loaderTxt: 'Carregando vista prévia...'
        }
      },
      split_and_crop: {
        title: 'Carga de arquivo',
        processedFiles: 'Arquivos processados',
        subtitle: 'Selecione o arquivo a ser processado',
        description:
          'O arquivo que vai carregar na plataforma tem que ser o pdf lençol original</br>Vamos dividi-lo para você poder assinar externamente e publicá-lo',
        label: 'Selecione seu arquivo pdf',
        uploadingFile: 'Carregando arquivo',
        wrongFiletype: 'O arquivo deve ter extensão .pdf',
        proccessWait:
          'Este processo pode demorar uns minutos<br>Você pode consultar em <strong><u><a href="{link}">Status de processos</a></u></strong>',
        documentsProcessed: 'Total de arquivos divididos',
        howToSignDocuments: 'Como assino os documentos digitalmente?',
        howToSignDocuments_1_1: 'Descarregar o Arquivo ',
        howToSignDocuments_1_2:
          'Assine os documentos externamente de forma digital',
        howToSignDocuments_1_3: 'Carrega o arquivo .zip com os pdf assinados',
        preview: 'Vista prévia do arquivo',
        download_file: 'Descarregar arquivo',
        download_file_loader: 'Descarregando',
        next: 'Seguinte',
        modalCancel: {
          title: 'Publicação de documentos',
          title_container:
            'Você tem certeza de que deseja cancelar a publicação?',
          description: 'Você perderá os documentos processados',
          cancel: 'Cancelar',
          confirm: 'Aceitar'
        },
        modalPreviewDocument: {
          title: 'Vista prévia',
          buttonClose: 'Fechar vista prévia',
          loaderTxt: 'Carregando vista prévia...'
        }
      },
      split_crop_and_sign: {
        title: 'Carga de arquivo e assinatura de documento',
        subtitle: 'Selecione o arquivo a ser processado',
        description:
          'O arquivo que vai carregar na plataforma tem que ser o pdf lençol original</br>Vamos dividir e assiná-lo na plataforma',
        label: 'Selecione seu arquivo pdf',
        wrongFiletype: 'O arquivo deve ter extensão .pdf',
        uploadingFile: 'Carregando arquivo',
        proccessWait:
          'Este processo pode demorar alguns minutos<br>Você pode consultar em <strong><u><a href="{link}">Status de processos</a></u></strong>',
        pdfSplited: 'PDFs Cortados',
        preview: 'Vista prévia do arquivo',
        goToList: 'Voltar à lista',
        documentsProcessed: '<strong>{input}</strong> Documentos processados',
        next: 'Assinar e publicar',
        modalCancel: {
          title: 'Eliminar documento',
          description: 'Você tem certeza de que quer eliminar o documento?',
          cancel: 'Cancelar',
          confirm: 'Sim, eliminar'
        },
        modalSignAndPublish: {
          title: 'Assinatura eletrônica',
          titleSelect: 'Selecionar certificado de assinatura',
          description:
            'Para poder assinar esta publicação você tem que digitar a senha do <strong>certificado eletrônico</strong>',
          descriptionSelect:
            'Selecione o certificado para assinar os documentos',
          buttonSelect: 'Selecionar',
          advise:
            'Quando confirmar os seus documentos, eles vão ser disponibilizados para os seus colaboradores',
          selected: 'Certificado de assinatura selecionado',
          changeCertificate: 'Trocar de certificado',
          labelInput: 'Digite a senha',
          cancel: 'Cancelar',
          confirm: 'Confirmar',
          noCert:
            'Não foi detectado um certificado de empresa para ser utilizado',
          SIGN_DOCUMENT_CERT_NO_EXISTS:
            'Você não tem um certificado ativo para fazer a publicação',
          SIGN_DOCUMENT_CERT_PASSWORD_INVALID: 'Senha incorreta',
          SIGN_DOCUMENT_TAG_NOT_FOUND: 'Houve um erro, consulte com suporte',
          SIGN_DOCUMENT_INVALID_TAG: 'Houve um erro, consulte com suporte',
          SIGN_DOCUMENT_INVALID_TAG_PARAMETER_TYPE:
            'Houve um erro, consulte com suporte',
          SIGN_DOCUMENT_INVALID_DOCUMENT_TYPE:
            'Houve um erro, consulte com suporte',
          SIGN_DOCUMENT_NOT_CREATED: 'Houve um erro, consulte com suporte'
        },
        modalPreviewDocument: {
          title: 'Vista prévia',
          buttonClose: 'Fechar vista prévia',
          loaderTxt: 'Carregando vista prévia...'
        }
      },
      configIndivualPublish: {
        title: 'Publicação individual',
        subtitle: 'Configuração inicial',
        inputCuil: {
          label: 'CPF',
          question: 'Qual o CPF do colaborador?',
          description:
            'Digite o CPF do colaborador para quem quer enviar um documento'
        },
        inputPeriod: {
          label: 'Selecione o período ao qual pertence o documento',
          question: 'A que mês corresponde o documento?',
          description:
            'Selecione o mês ao qual pertence o documento que vai disponibilizar para seu colaborador. ' +
            'Disponível 1 mês para frente e até 12 meses para trás'
        },
        inputDocumentType: {
          label: 'Selecione um tipo de documento',
          question: 'Qual documento vai enviar para seu colaborador?',
          description:
            'Selecione dentre os diferentes tipos de documentos carregados no sistema para publicar',
          noDocuments: 'O documento não foi encontrado',
          signMessage: {
            required: 'Este documento precisa de assinatura',
            notRequired: 'Este documento não precisa de assinatura'
          }
        },
        checkDocumentSign: {
          label: 'Incluir assinatura da empresa',
          question: 'Você quer assinar os documentos?',
          description:
            'O documento passará primeiro pelo processo de assinatura no qual será aplicada a assinatura da empresa'
        },
        checkNotificationMail: {
          label: 'Enviar e-mail',
          question: 'Você vai notificar ao colaborador?',
          description:
            'Seu colaborador receberá um e-mail e/ou notificação push avisando que tem uma nova publicação para revisar'
        },
        checkPushNotification: {
          label: 'Enviar notificação push'
        },
        publishLoadDocument: {
          label: 'Selecione seu arquivo',
          question: 'Selecione o arquivo a ser enviado',
          description: 'Você pode utilizar os seguintes tipos de arquivos',
          filePreview: 'Vista prévia do arquivo'
        },
        action: {
          cancel: 'Cancelar',
          publish: 'Enviar documento',
          publishAndSign: 'Assinar e publicar'
        },
        modal: {
          success: 'Publicação feita com sucesso',
          publicNew: 'Você quer enviar um outro documento para um colaborador?',
          description:
            'Você pode continuar fazendo envios de documentos para seus colaboradores',
          leave: 'Sair',
          publicOther: 'Publicar outro documento'
        },
        errors: {
          SYSTEM_API_INVALID_CUIL: 'O CPF é inválido',
          SYSTEM_API_NOT_CREATE_DIRECTORY: 'Não foi possível criar o diretório',
          SYSTEM_API_FILE_EXISTS: 'O arquivo já existe',
          SYSTEM_API_NOT_CREATE_REGISTRY_CARGA:
            'Não foi possível criar o registro de carga',
          SYSTEM_API_DOCUMENT_NOT_PUBLISHED:
            'O documento não pôde ser publicado',
          SYSTEM_API_NOT_SEND_NOTIFICATION:
            'Não foi possível enviar a notificação',
          SYSTEM_API_PARAMETER_NOT_EXPECTED:
            'Um ou vários parâmetros são inválidos',
          SYSTEM_API_NOT_MOVE_FILE:
            'O arquivo não pôde ser movido para a pasta',
          SYSTEM_API_PARAMETER_REQUIRED:
            'Um ou vários parâmetros são requeridos',
          PDF_FILE_PAGE_SIZE_EXCEPTION:
            'O tamanho de folha do pdf não está permitido para a publicação',
          SIGN_DOCUMENT_CANNOT_CREATE_DIRECTORY:
            'Não é possível criar o diretório de processos',
          SIGN_DOCUMENT_CANNOT_UNZIP_FILE:
            'Não é possível descomprimir o arquivo carregado',
          SIGN_DOCUMENT_CERT_HAS_EXPIRED: 'O certificado expirou',
          SIGN_DOCUMENT_CERT_PASSWORD_INVALID:
            'O password do certificado não é válido',
          SIGN_DOCUMENT_INVALID_OUTPUT_JSON:
            'Não é possível obter a rota da pasta',
          SIGN_DOCUMENT_INVALID_OUTPUT: 'A saída programada não é válida',
          SIGN_DOCUMENT_INVALID_TAG_OUTPUT_STATUS:
            'O status de saída da tarefa programada não é válido',
          SIGN_DOCUMENT_CERT_NO_EXISTS:
            'Você não tem um certificado ativo para fazer a publicação',
          SIGN_DOCUMENT_TAG_NOT_FOUND: 'Houve um erro, consulte com suporte',
          SIGN_DOCUMENT_INVALID_TAG: 'Houve um erro, consulte com suporte',
          SIGN_DOCUMENT_INVALID_TAG_PARAMETER_TYPE:
            'Houve um erro, consulte com suporte',
          SIGN_DOCUMENT_INVALID_DOCUMENT_TYPE:
            'Houve um erro, consulte com suporte',
          SIGN_DOCUMENT_NOT_CREATED: 'Houve um erro, consulte com suporte',
          '268': 'Este PDF se encontra encriptado e não pode ser processado'
        },
        signatureAlert: {
          message:
            'Não se encontrou uma configuração de assinatura para a empresa, por favor vá para configuração de pastas',
          configButton: 'Configurar assinatura'
        }
      },
      configGenericPublish: {
        title: 'Publicação Genérica',
        subtitle: 'Configuração inicial',
        withOutConfig:
          'Não se encontrou uma configuração de assinatura para a empresa, por favor vá para configuração de pastas',
        configSign: 'Configurar assinatura',
        sign: {
          required: 'Este documento precisa de assinatura',
          notRequired: 'Este documento não precisa de assinatura'
        },
        maxFileSize: 'O documento não deve ultrapassar os 1MB',
        fileType: 'O tipo de documento não é permitido. Deve ser PDF.',
        sendDocument: 'Tem certeza de que quer enviar o documento?',
        cancel: {
          question: 'Tem certeza de que quer sair da publicação?',
          message:
            'Quando sair, o documento e a informação carregada serão eliminados'
        },
        confirmOut: 'Sim, sair',
        okMessage: 'Entendido',
        inputDocumentType: {
          label: 'Selecione um tipo de documento',
          question: 'Qual documento vai enviar para seus colaboradores?',
          description:
            'Selecione dentre os diferentes tipos de documentos carregados no sistema para publicar',
          noDocuments: 'O documento não foi encontrado'
        },
        inputSector: {
          title: 'Setor',
          label: 'Selecione um setor',
          question: 'Selecione setor, locação ou cargo',
          description:
            'Selecione o setor, a locação e o cargo de quem vai receber este documento',
          clear: 'Limpar seleção',
          noResult: 'Não há setores',
          required: 'Este campo é requerido'
        },
        inputLocation: {
          title: 'Locação',
          label: 'Selecione uma locação',
          clear: 'Limpar seleção',
          noResult: 'Não há locações',
          required: 'Este campo é requerido'
        },
        checkNotificationMail: {
          label: 'Enviar e-mail',
          question: 'Você quer notificar o colaborador?',
          description:
            'Seus colaboradores vão receber um e-mail notificando que têm uma nova publicação para revisar'
        },
        PrePublicationValidator: {
          label: 'Sim, validar',
          question: 'Validar publicação anterior?',
          description:
            'Será verificado se existe uma versão deste tipo de documento que já tenha sido publicada anteriormente. Se for o caso, ela será publicada apenas para os colaboradores que ainda não a tenham em sua bandeja de documentos.'
        },
        publishLoadDocument: {
          label: 'Selecione seu arquivo',
          question: 'Selecione o arquivo a ser enviado',
          description: 'Você pode utilizar os seguintes tipos de arquivos',
          filePreview: 'Vista prévia do arquivo'
        },
        action: {
          cancel: 'Cancelar',
          publish: 'Enviar documento'
        },
        modal: {
          success: 'Publicação feita com sucesso',
          publicNew:
            'Você quer enviar um outro documento para os colaboradores?',
          description:
            'Você pode continuar fazendo envios de documentos para seus colaboradores',
          leave: 'Sair',
          publicOther: 'Publicar outro documento'
        },
        errors: {
          SYSTEM_API_PARAMETER_NOT_EXPECTED:
            'Um ou vários parâmetros são inválidos',
          SYSTEM_API_PARAMETER_REQUIRED:
            'Um ou vários parâmetros são requeridos',
          PDF_FILE_PAGE_SIZE_EXCEPTION:
            'O tamanho de folha do pdf não está permitido para a publicação',
          SYSTEM_API_MAX_FILE_SIZE_EXCEEDED:
            'O tamanho do pdf ultrapassa o permitido',
          SYSTEM_API_INVALID_LOCACION: 'A locação é inválida',
          SYSTEM_API_INVALID_SECTOR: 'O setor é inválido',
          SYSTEM_API_INVALID_SUBFOLDERID:
            'O id do tipo de documento é inválido',
          SYSTEM_API_NOT_CREATE_DIRECTORY: 'Não foi possível criar o diretório'
        },
        inputCargo: {
          title: 'Cargo',
          label: 'Selecione um cargo',
          clear: 'Limpar seleção',
          noResult: 'Não há cargos',
          required: 'Este campo é requerido'
        },
        tab: {
          title: 'Configuração inicial',
          byCategory: 'Por Categorias',
          byFile: 'Por CSV'
        }
      },
      errors: {
        SYSTEM_API_WRONG_MIME_TYPE: 'O arquivo tem um formato inválido',
        SYSTEM_API_ZIP_SUSPICIOUS_FORMAT:
          'O arquivo ZIP tem um formato suspeito ou inseguro',
        PUBLISH_DOCUMENT_MASSIVE_INVALID_UNZIP_PDF_FILES:
          'Arquivo inválido. Não foi possível descomprimi-lo',
        PUBLISH_DOCUMENT_MASSIVE_ZIP_WAITING_PROCESSED:
          'Já existe um ZIP esperando por ser processado',
        PUBLISH_DOCUMENT_MASSIVE_INVALID_DOCUMENTS_COUNTS:
          'Arquivo inválido, por cada PDF deve ter um XML',
        PUBLISH_DOCUMENT_MASSIVE_INVALID_UNZIP:
          'Arquivo ZIP inválido, não é possível descomprimi-lo',
        SYSTEM_API_INVALID_SUBFOLDERID: 'ID de subpasta inválido',
        PDF_FILE_PAGE_SIZE_EXCEPTION:
          'O tamanho de página do PDF não está permitido',
        SYSTEM_API_MAX_FILE_SIZE_EXCEEDED:
          'O arquivo não pode ultrapassar os 750 MB',
        SIGN_DOCUMENT_CERT_NO_EXISTS:
          "Neste momento não há um certificado ativo para a assinatura e publicação.<br><span class='text-base mt-4'>Por favor, para continuar, gere um novo certificado na seção de Certificados de assinatura eletrônica.</span>",
        ERROR_CANCEL_PROCESS:
          'Houve um erro eliminando o documento<br>Por favor, entre em contato com suporte',
        PAGE_REQUESTED_NOT_FOUND:
          'A página que está querendo visualizar não se encontra no arquivo',
        ERROR_PREVIEW_GENERAL:
          'Houve um erro inesperado<br>Por favor, entre em contato com suporte',
        EMAIL_VALUE_IS_INVALID: 'O e-mail digitado não é válido',
        4: 'O arquivo PDF está corrompido ou é inválido. Tente carregar outro arquivo.',
      },
      modals: {
        notification: {
          title: 'Enviar documento',
          question: 'Tem certeza de que quer enviar o documento',
          cancel: 'Cancelar',
          send: 'Enviar documento',
          onlyUnreceivedCollaborators: 'Este tipo de documento só será publicado para os colaboradores que não o tenham recebido anteriormente.' 
        },
        error: {
          title: 'Documento novo',
          ok: 'Entendido'
        }
      }
    },
    certificates: {
      title: 'Certificados de assinatura eletrônica',
      createCert: 'Criar certificado',
      createAlertTitle:
        'Você atingiu a quantidade máxima de certificados ativos na empresa.',
      createCertAlertSteps: 'Para criar um novo você pode:',
      createCertAlertSteps_1: 'Expirar um certificado existente',
      createCertAlertSteps_2: 'Aguardar o vencimento de um certificado ativo',
      newCertificate: {
        title: 'Dados requeridos para a criação do certificado',
        subtitle:
          'Preencha os seguintes campos para gerar o certificado a ser assinado eletronicamente.<br>O certificado é só um por empresa.',
        required: '* Todos os campos são obrigatórios',
        personalInfo: {
          title: 'Dados pessoais',
          subtitle:
            'Preencha os campos correspondentes com seus dados pessoais',
          nameAndSurname: 'Nome e Sobrenome',
          position: 'Cargo na empresa',
          email: 'E-mail',
          dni: 'CPF'
        },
        companyInfo: {
          title: 'Dados da empresa',
          subtitle:
            'Preencha os campos correspondentes com os dados da empresa',
          name: 'Razão social',
          uniqueId: 'Identificador único da empresa'
        },
        password: {
          title: 'Senha',
          subtitle: 'Substituir por política de senha por empresa',
          password: 'Digite senha',
          repeatPassword: 'Confirmar senha'
        },
        signView: 'Visualização de assinatura em documentos',
        signInfo:
          'O colaborador vai visualizar a assinatura eletrônica da seguinte forma',
        signElectronic: 'ASSINADO ELETRONICAMENTE',
        signName: 'NOME E SOBRENOME',
        signCharge: 'CARGO',
        dni: 'CPF',
        responsabilityTitle: 'Responsabilidade do uso de certificados',
        responsabilityLegend:
          'Sou ciente de estar habilitado para a criação de certificados por parte da organização e o resguardo da senha gerada fica sob mina responsabilidade.',
        responsabilityCheckbox: 'Entendido',
        cancel: 'Cancelar',
        cancelQuestion: 'Deseja cancelar a criação do certificado?',
        cancelDataLost: 'Os dados preenchidos vão se perder.',
        accept: 'Aceitar',
        create: 'Criar certificado',
        successTitle: 'Certificado criado',
        successText: 'Certificado criado com sucesso',
        errors: {
          title: 'Houve um erro',
          '00026':
            'O password já foi utilizado anteriormente, por favor digite outro password e tente novamente',
          '00141':
            'O password não cumpre com as políticas de senha da empresa, por favor verifique o password e tente novamente',
          generic:
            'Houve um erro na hora de criar o certificado. Por favor, entre em contato com suporte'
        },
        gotIt: 'Entendido'
      },
      emptyState: {
        title: 'Isto é um deserto...',
        noCert:
          'Você não possui um certificado ativo para assinar os documentos',
        noCert2: 'Não há documentos novos no seu painel de tarefas',
        createCert:
          'Para criar um novo clique no botão <strong>Criar certificado</strong>'
      },
      certificatesList: {
        activeTitle: 'Certificado ativo',
        expiredTitle: 'Certificados expirados',
        createdBy: 'Criado por <strong>{input}</strong>',
        creationDate: 'Data criação <strong>{input}</strong>',
        validDate: 'Válido até {input}',
        expiredDate: 'Expirado {input}',
        btnCertificate: 'Ver certificado',
        btnExpireCertificate: 'Expirar',
        certificateModal: {
          closeBtn: 'Fechar',
          modalTitle: 'Vista do certificado',
          certExpired: 'Certificado expirado',
          certActive: 'Certificado ativo',
          validDate: 'Válido até {input}',
          expiredDate: 'Expirado {input}',
          personalDataTitle: 'Dados pessoais',
          fullName: 'Nome e Sobrenome',
          position: 'Cargo na empresa',
          email: 'E-mail',
          companyDataTitle: 'Dados da empresa',
          companyName: 'Razão social',
          companyCuit: 'CNPJ'
        }
      },
      expireCertificate: {
        expireModalTitle: 'Expirar certificado',
        expireModalBodyTitle: 'Tem certeza de expirar este certificado?',
        expireModalSubtitle:
          'O certificado ficará inativo e não poderá ser utilizado novamente.',
        errors: {
          COMPANY_CERT_ALREADY_EXPIRED: 'O certificado já expirou',
          COMPANY_CERT_NOT_FOUND: 'Não se encontra o certificado',
          COMPANY_CERT_INVALID_UNIQUE_ID_LENGTH: 'O identificador único do certificado tem um comprimento inválido'
        }
      }
    },
    employees: {
      administration: {
        error: {
          SYSTEM_API_INVALID_PROFILE_TYPE_ID:
            'ID não é um tipo de perfil válido',
          SYSTEM_API_INVALID_CUIL: 'CPF inválido',
          SYSTEM_API_PARAMETER_REQUIRED:
            'profileTypesId é um parâmetro requerido',
          SYSTEM_API_WRONG_MIME_TYPE:
            'Formato de arquivo incorreto, o arquivo carregado deve ser em formato .csv'
        },
        message: {
          error: 'O arquivo não foi processado pelos seguintes motivos',
          info: 'O processo foi completado, mas com erros',
          success: 'Processo completado!',
          inserted: {
            label: 'Foram atualizados {quantity} usuários de {total} usuários.'
          },
          failed: {
            observation: 'Não existe o usuário',
            label: 'Falharam {quantity} usuários de {total} usuários.',
            link: 'Clique para descarregar a lista de falhas.'
          },
          inactive: {
            observation: 'O usuário está inativo',
            label: 'Usuários inativos {quantity} de {total} usuários.'
          },
          duplicates: {
            observation:
              'Já foi atualizado um registro prévio com este identificador',
            label:
              'Foram detectados {quantity} registros duplicados dos {total} usuários informados.',
            link: 'Clique aqui para descarregar a lista de duplicados no arquivo.'
          }
        },
        profileIntegration: {
          title: 'Gestão perfis de integração',
          subTitle: 'Gestão de perfis',
          name: 'Perfis de integração',
          step: {
            question: '1. Faça uma lista de contas de usuário',
            description:
              'Crie um arquivo CSV para montar a lista de usuários. ',
            link: 'Você pode descarregar este exemplo para preencher'
          },
          step1: {
            question: '2. Perfis de integração',
            assign: 'Designar',
            unassign: 'Eliminar',
            noResult: 'Não há perfis',
            add: 'Adicionar'
          },
          step2: {
            question: '3. Subir arquivo',
            selectFile: 'Selecione um arquivo'
          },
          help: 'Precisa de ajuda?',
          toSaveAssign: 'Designar perfil',
          toSaveUnassign: 'Eliminar perfil',
          validFile: 'O arquivo deve ter extensão .csv'
        }
      }
    },
    updateLogo: {
      saveButton: 'Salvar',
      cancelButton: 'Cancelar',
      modalConfirm: 'Confirmar',
      subtitle: 'Imagem carregada',
      title: 'Utilizado atualmente',
      header: 'Atualização de marca',
      newLogoPlaceholder: 'Logo novo',
      uploadingFile: 'Carregando arquivo',
      actualLogoPlaceholder: 'Logo atual',
      modalHeader: 'Confirmar atualização',
      inputPlaceholder: 'Selecione um arquivo',
      modalTitle: 'Tem certeza de que quer aplicar esta modificação de marca?',
      modalText:
        'Esta modificação afetará a marca da empresa que visualizam todos os seus colaboradores.',
      errors: {
        unauthorized: 'Acesso denegado',
        wrongType: 'O tipo de arquivo não é permitido',
        parameterExpected: 'Preencha o parâmetro "logo"',
        exception: 'O logotipo da empresa não pode ser salvo',
        maxSizeExceeded: 'O tamanho do arquivo ultrapassa o limite permitido'
      }
    },
    updateColors: {
      header: 'Paleta de cores',
      title: 'Personaliza as cores de sua plataforma',
      description:
        'As alterações feitas na paleta de cores, aparecerão na barra lateral, botões e nalguns detalhes da plataforma, será visível para todos os seus colaboradores.',
      subtitle: 'Cores base',
      subtitle2: 'Cores títulos',
      inputColor1: 'Cor primária (Sidebar, botões)',
      inputColor2:
        'Cor secundária  ( Quando o usuário localiza o cursor sobre o ícone )',
      inputColor3: 'Cor ativa  ( Quando a opção estiver selecionada )',
      inputTitle: 'Cor primária (títulos)',
      iconTextDescription:
        'Isto afeta o texto do menu lateral e o texto dos ícones',
      inconTextTitle: 'Cor de texto em ícones',
      black: 'Preto',
      white: 'Branco',
      restoreDefault: 'Restabelecer cores da plataforma',
      restoreDefaultDescription: 'Restabelecer cores por default',
      cancelButton: 'Cancelar',
      saveButton: 'Salvar',
      modalHeader: 'Confirmar atualização',
      modalTitle:
        'Tem certeza de que quer aplicar esta modificação na paleta de cores?',
      modalText:
        'Esta modificação afetará as cores visualizadas por seus colaboradores na plataforma',
      modalConfirm: 'Confirmar',
      previewHeader: 'Vista prévia da paleta de cores',
      previewClose: 'Fechar',
      modalReturn: {
        title: 'Deseja sair?',
        cancelQuestion: 'Tem certeza de que deseja sair?',
        cancelDataLost: 'As alterações feitas vão se perder.',
        cancel: 'Não, continuar',
        accept: 'Sim, sair'
      },
      preview: 'Vista prévia',
      validation: {
        required: 'Este campo é requerido',
        hexFormat: 'Só se admite formato de cor tipo HEX'
      }
    },
    main_bussines_page: {
      payroll: {
        title: 'Nômina',
        payrollConfig: 'Configuração da nômina',
        description: 'Permite habilitar funcionalidades de Nômina',
        config: {
          title: 'Funcionalidades de Nômina',
          subtitle: 'Configuração',
          formQuestion:
            'Você quer habilitar seu colaborador para poder solicitar adiantamentos?',
          caption:
            'Permitir que seu colaborador solicite adiantamentos de salários',
          radioOk: 'Sim, permitir',
          radioNot: 'Não permitir'
        },
        confirmModal: {
          title: 'Nômina',
          subtitle: 'Configuração da nômina',
          confirmQuestion:
            'Tem certeza de que quer alterar a configuração de pedidos de adiantamentos?',
          cancel: 'Cancelar',
          confirm: 'Aceitar'
        }
      },
      business: {
        title_bussines: 'Empresa',
        folder_settings: 'Configuração de pastas',
        subtitle_folder_settings:
          'Define as pastas e onde serão armazenados os diferentes documentos',
        news_billboard: 'Painel de notícias',
        subtitle_news_billboard:
          'Publica notícias na tela inicial do seu colaborador'
      },
      workflow: {
        title_workflow: 'Fluxo de trabalho',
        workflow_creation: 'Gestão de fluxos',
        subtitle_workflow_creation:
          'Estabelece por quem vão passar os documentos para serem aprovados',
        group_management: 'Gestão de grupos',
        subtitle_group_management:
          'Define como vão se conformar os grupos de aprovadores',
        configuration: {
          create: 'Criar fluxo de trabalho',
          title: 'Configuração',
          flow_name: {
            title: 'Qual o nome deste fluxo de trabalho?',
            description:
              'O nome vai servir para identificar quem são os envolvidos na ordem de aprovação e os documentos, tente utilizar um nome descritivo',
            input_placeholder: 'Nome do fluxo de trabalho'
          },
          selection_approves: {
            title: 'Seleção de aprovadores',
            description:
              'Por favor, selecione os aprovadores do circuito de aprovação,\n' +
              'lembre a ordem selecionada, será a mesma em que serão aprovados',
            subsection_title: 'Ordem de aprovação',
            select_placeholder: 'Pesquise ou selecione da lista',
            add_other_approves: 'Adicionar outro'
          },
          selection_document: {
            title: 'Seleção de documentos',
            description:
              'Por favor, selecione os documentos que deverão passar pelo circuito de aprovação, tais documentos não poderão ser utilizados em outro circuito',
            subsection_title: 'Documento',
            select_placeholder: 'Selecione o tipo de documento',
            add_other_document: 'Adicionar outro'
          },
          button_save: 'Salvar',
          button_cancel: 'Cancelar',
          button_cancel_alt: 'Sim, sair',
          buttonBack: 'Voltar',
          noDocuments: 'O documento não foi encontrado'
        },
        modals: {
          create: {
            title: 'Salvar fluxo de trabalho',
            body: 'Tem certeza de que quer salvar o Fluxo de trabalho',
            var_body: '{name}?',
            body_success:
              'O fluxo de trabalho com nome {name} foi criado com sucesso',
            body_error: 'Houve um erro na hora de criar o fluxo de trabalho',
            button_success: 'Fechar'
          },
          destroy: {
            title: 'Sair de fluxos de trabalho',
            body_title: 'Tem certeza de que quer sair?',
            body: 'Você pode continuar com este fluxo de trabalho em qualquer momento acessando Gestão de fluxos (será guardado como rascunho)'
          },
          errors: {
            DOCUMENT_EXISTS_IN_WORKFLOW:
              'O documento existe em outro fluxo de trabalho',
            INCORRECT_APPROVING_GROUP: 'O grupo aprovador é incorreto',
            SYSTEM_API_WRONG_DATA_TYPE:
              'Os valores do tipo de dado são incorretos'
          },
          disabled: {
            title: 'Desativar fluxo',
            body_title: 'Tem certeza de querer desativar este fluxo?',
            body: 'Este fluxo será desativado e já não poderá ser utilizado',
            cancel: 'Cancelar',
            action: 'Desativar'
          },
          groups: {
            title: 'Membros do grupo',
            action: 'Fechar'
          }
        },
        table: {
          title: 'Fluxos criados',
          headers: {
            date: 'Data',
            actions: 'Ações',
            modifiedby: 'Modificado por',
            status: 'Status',
            groups: 'Grupos',
            nameWorkflow: 'Nome do workflow'
          },
          badge: {
            cancelled: 'Cancelado',
            active: 'Ativo'
          },
          tooltipGroup: 'Ver membros do grupo',
          tooltipCancel: 'Desativar fluxo'
        }
      },
      notifications: {
        title_notifications: 'Configuração de notificações',
        welcome_email: 'E-mail de boas-vindas',
        subtitle_welcome_email:
          'Envie um e-mail para os seus colaboradores com as boas-vindas à plataforma',
        Personalize_emails: 'Personalizar e-mails',
        subtitle_Personalize_emails:
          'Modifique as comunicações que irão receber seu colaborador'
      },
      personalization: {
        title_personalization: 'Personalização',
        brand_update: 'Atualização de marca',
        subtitle_brand_update:
          'Você pode substituir a imagem corporativa na plataforma',
        color_palette: 'Paleta de cores',
        subtitle_color_palette:
          'Selecione ou personalize as cores da plataforma'
      },
      other_settings: {
        title_other_settings: 'Segurança',
        mfa: 'MFA dupla autenticação',
        subtitle_mfa:
          'Confira se seus colaboradores têm duplo fator de autenticação',
        audit: 'Auditoria',
        subtitle_audit: 'Faça auditorias das ações executadas na plataforma',
        security_Center: 'Centro de segurança',
        subtitle_security_center:
          'Administre as permissões de seus colaboradores na plataforma',
        manager_management: 'Gestão de managers',
        subtitle_manager_management:
          'Administrar perfil de manager e as pastas que podem visualizar'
      },
      onboarding: {
        title_onboarding: 'Onboarding',
        onboarding_settings: 'Configuração onboarding',
        subtitle_onboarding_settings:
          'Estabeleça os dados a serem pedidos a seu colaborador no onboarding'
      },
      certificate: {
        title_certificate: 'Certificados',
        electronic_sign_cert: 'Certificados de assinatura eletrônica',
        subtitle_electronic_sign_cert: 'Certificados de assinatura eletrônica'
      },
      self_service: {
        title_self_service: 'Gestão de autosserviço para dados do colaborador',
        data_update: 'Atualização de dados',
        subtitle_data_update:
          'Habilite a opção para seu colaborador atualizar os seus dados',
        bank_data: 'Dados bancários',
        subtitle_bank_data: 'Faça auditorias das ações executadas na plataforma'
      }
    },
    cancelDocuments: {
      info: 'Os documentos selecionados foram anulados com sucesso',
      error: {
        GENERIC: 'Não foi possível anular os documentos, tente mais tarde',
        MASSIVE_CANCEL_NONEXISTENT: 'Os ids não existem',
        MASSIVE_CANCEL_DUPLICATE: 'Há ids duplicados',
        SYSTEM_API_PARAMETER_REQUIRED: 'Ids é um parâmetro requerido',
        SYSTEM_API_WRONG_DATA_TYPE: 'Valor de tipo de dados incorreto - ids',
        SYSTEM_API_MAX_ARRAY_COUNT_EXCEEDED:
          'Ultrapassou o número máximo de ids.'
      },
      heading: 'Anular documentos',
      title: 'Tem certeza de querer anular os documentos selecionados?',
      content: 'Só serão eliminados os documentos selecionados da página atual',
      footer: {
        cancel: 'Cancelar',
        cancelled: 'Sim, anular'
      }
    },
    selfService: {
      taskManager: {
        contact: 'Dados de contato',
        bank: 'Dados bancários',
        identifies: 'Como me identifico',
        address: 'Alteração do endereço',
        field: {
          cbuAlias: 'Número de conta',
          contactPerson: 'Pessoa de contato de emergência',
          contactType: 'Tipo de contato',
          emergencyPhone: 'Telefone de emergência',
          personalPhone: 'Telefone celular',
          personalPhoneHouse: 'Telefone fixo',
          bank: 'Selecione o seu banco',
          bankAccountType: 'Tipo de conta',
          myNickName: 'Nickname',
          nameBank: 'Banco',
          cbu: 'Número de conta',
          copy: 'Colar Número de conta',
          download: 'Descarregar',
          myName: 'Como você prefere ser chamado?',
          myLastName: 'Qual é seu sobrenome',
          myGenre: 'Gênero',
          country: 'País de residência',
          state: 'Província / Estado',
          city: 'Cidade',
          street: 'Rua',
          addressNumber: 'Número',
          floor: 'Andar',
          department: 'Apartamento',
          neighborHood: 'Bairro',
          blockStreet: 'Quarteirão',
          addressType: 'Tipo de endereço',
          myAvatar: 'Foto atualizada',
          cci: 'Número de conta interbancária',
          payment_type: 'Tipo de pagamento',
          account_number: 'Número de conta'
        },
        fieldsError: {
          nickName: {
            required: 'O Nome é requerido',
            regex: 'Só se admitem letras',
            min: 'Não cumpre com o mínimo de caracteres',
            max: 'Ultrapassou o máximo de caracteres'
          },
          nameBank: {
            regex: 'Só se admitem números e letras',
            min: 'Não cumpre com o mínimo de caracteres',
            max: 'Ultrapassou o máximo de caracteres'
          },
          cbu: {
            regex: 'Só se admitem números e letras',
            min: 'Não cumpre com o mínimo de caracteres',
            max: 'Ultrapassou o máximo de caracteres'
          },
          typeAccount: {
            regex: 'Só se admitem números e letras',
            min: 'Não cumpre com o mínimo de caracteres',
            max: 'Ultrapassou o máximo de caracteres'
          }
        },
        fieldRequired: 'Este campo é requerido'
      },
      statusOk: 'A informação do usuário foi alterada com sucesso',
      errors: {
        ACTION_ALREADY_EXISTS: 'Estas ações já existem',
        FAILED_SAVE_DATA:
          'Não foi possível salvar a configuração, tente novamente, se o erro permanecer, entre em contato com suporte',
        SYSTEM_API_PARAMETER_REQUIRED: 'Um ou vários parâmetros são requeridos',
        SYSTEM_API_WRONG_DATA_TYPE:
          'Há campos que contêm um valor de tipo incorreto',
        EXPECTED_PARAMETER_VALUE: 'Um ou vários campos são requeridos',
        FAILED_DELETE_ACTION: 'Houve um erro na hora de eliminar a permissão',
        NOT_FOUND_FOLDER_CONFIG:
          'A configuração de pasta para armazenar os documentos não foi encontrada'
      },
      title: 'Atualização de dados',
      subTitle: 'Configuração',
      linkBack: 'Voltar',
      linkCancel: 'Cancelar',
      linkSave: 'Salvar',
      linkSaveChanged: 'Salvar Alterações',
      linkSaveInformation: 'Salvar Informação',
      linkDownloadPicture: 'Descarregar foto',
      success: 'A configuração foi salva com sucesso',
      isOk: 'Entendido',
      linkLeave: 'Sim, sair',
      leaveQuest: 'Tem certeza de que quer sair da configuração?',
      radioOk: 'Sim, permitir',
      radioNot: 'Não permitir',
      addressQuest:
        'Você quer habilitar seu colaborador para ele atualizar o seu endereço?',
      addressDescription:
        'Permitir que seu colaborador atualize seu local de residência, selecionando país, cidade e endereço',
      bankQuest:
        'Você quer habilitar seu colaborador para ele atualizar seus dados bancários?',
      bankDescription:
        'Permitir que seu colaborador atualize o banco onde vai receber seu salário, selecionando o banco e preenchendo o número de conta/agência',
      contactQuest:
        'Você quer habilitar seu colaborador para ele atualizar seus dados de contato?',
      contactDescription:
        'Permitir que seu colaborador atualize seu telefone de contato e de emergência',
      identifiesQuest:
        'Você quer habilitar seu colaborador para ele atualizar como se identifica (gênero)?',
      identifiesDescription:
        'Permitir que seu colaborador atualize como ele se percebe, poderá preencher seu nome, sobrenome, gênero e uma foto (opcional)',
      infoEmployee: {
        tab: {
          personalData: 'Dados pessoais',
          contactData: 'Dados de contato',
          bankData: 'Dados bancários',
          identificationData: 'Como me identifico',
          addressData: 'Dados de endereço'
        }
      },
      whereToStoreDocument: 'Onde você deseja armazenar o documento?',
      selectFolderForUpdateDocument:
        'Selecione uma pasta onde vai se guardar o documento de atualização de endereço do colaborador (declaração juramentada)',
      whichTypeToStoreDocument: ' Selecione tipo de documento',
      selectFolderError: 'Houve um erro na configuração de pastas',
      selectFolder: 'Selecione uma pasta',
      selectDocumentType: 'Selecione um tipo de documento'
    },
    company: {
      welcomeEmail: {
        title: 'E-mail de boas-vindas',
        subTitle: 'Este é o e-mail que vão receber os seus colaboradores',
        description:
          'Aqui você poderá visualizar o conteúdo do e-mail que vão receber os seus colaboradores no e-mail cadastrado na plataforma',
        actionCancel: 'Cancelar',
        actionSend: 'Envio e-mails de boas-vindas',
        actionOk: 'Aceitar',
        actionBack: 'Voltar',
        messageSended:
          'Foi enviado o e-mail para todos os usuários que ainda não realizaram o primeiro acesso.',
        modal: {
          title: 'Envio de e-mails de boas-vindas',
          body: 'Você está por enviar o e-mail de boas-vindas para toda sua nômina ativa, este processo é de execução única. Deseja continuar?'
        },
        errors: {
          WELCOME_EMAIL_ALREADY_USED:
            'A empresa já realizou o envio de e-mails.',
          NOT_RESULT: 'Não há usuários novos para enviar o e-mail.',
          INVALID_TOKEN: 'Token de autenticação não válido',
          DEFAULT_ERROR:
            'Houve um erro na hora de tentar realizar o envio de e-mails.'
        }
      }
    },
    customEmails: {
      title: 'Personalizar e-mails',
      go_back_btn: 'Voltar',
      template: {
        edit_btn: 'Editar',
        empty_email_template:
          'Proximamente você poderá personalizar os e-mails correspondentes a esta seção.'
      },
      descriptionHeader:
        'Este é o e-mail que vão receber os seus colaboradores',
      description:
        'Aqui você poderá visualizar o conteúdo do e-mail que vão receber os seus colaboradores no e-mail cadastrado na plataforma',
      restoreDefault: 'Restabelecer seções por default',
      cancel: 'Cancelar',
      save: 'Salvar',
      edit: 'Editar',
      imgEdit: 'Editor de imagens',
      imgDescription: 'Alguns dados que você pode utilizar de forma dinâmica',
      restore: 'Restabelecer',
      accept: 'Aceitar',
      emptyLibrary: 'Ainda não existem imagens na biblioteca',
      load: 'Carregar',
      library: 'Biblioteca',
      errors: {
        COMPANY_GALLERY_LIMIT_EXCEPTION: 'Ultrapassou o limite de 20 imagens',
        IMAGE_LIMIT_SIZE: 'O arquivo não pode ultrapassar os 1 MB',
        IMAGE_TYPE: 'O arquivo deve ter extensão .jpg, .png'
      },
      succesMessage: 'Carga bem-sucedida',
      select_file: 'Selecionar um arquivo',
      cancelModal: {
        message:
          'Tem certeza de que deseja cancelar a personalização deste e-mail?',
        caption: 'Vão se perder os dados preenchidos.',
        confirmBtn: 'Sim, cancelar',
        cancelBtn: 'Não, continuar'
      },
      confirmModal: {
        message:
          'Tem certeza de que deseja aplicar as alterações neste modelo de correio?',
        confirmBtn: 'Salvar',
        cancelBtn: 'Cancelar'
      },
      alertInformation:
        'Só é possível carregar um máximo de 20 imagens. Elas não poderão ser eliminadas.',
      welcomeEmail: {
        welcome: 'Bem-vind@ a',
        accessCreated:
          'Foi criado seu usuário de acesso na plataforma Sichern, onde você vai poder preencher, assinar e visualizar todos os documentos laborais de {company}, a qualquer hora e em qualquer lugar.',
        accessInfo:
          'A seguir, compartilhamos a informação necessária para acessar o sistema por primeira vez, momento em que deverá alterar sua senha:',
        username: 'Usuário',
        password: 'Senha',
        enterSystem: 'Acessar o sistema',
        regards: 'Cumprimentos.',
        teamOf: 'Equipe de {company}',
        note: 'NOTA: Favor não responder esta mensagem que foi gerada automaticamente em Sichern. Esta comunicação (incluindo seus anexos) contém informação confidencial, dirigida exclusivamente para seu destinatário, quem deverá resguardar a confidencialidade. É proibida a divulgação, alteração, reprodução ou uso da informação aqui contida por qualquer outra pessoa que não seja seu destinatário'
      },
      categories: {
        labels: {
          workers: 'Colaboradores',
          documents: 'Documentos',
          licenses: 'Licenças',
          tasks: 'Bandeja de Tarefas',
          company: 'Empresa',
          reports: 'Relatórios'
        },
        colaboradores: {
          new_user: 'Cadastro de novo usuário (funcionário)',
          resetpass: 'Alteração de senha',
          unlock: 'Usuário Bloqueado',
          update_user_pass: 'Atualização de senha',
          update_user: 'Atualização de dados do usuário'
        },
        documentos: {
          new_doc_v2: 'Novo documento disponível (funcionário)',
          signature_reminder: 'Lembrete de assinatura',
          eforms: 'Novo formulário digital (Funcionário)',
          new_download_ready: 'Backup de documentos (Funcionário)'
        },
        licencias: {
          license_created: 'Nova solicitação de licença (Funcionário)',
          license_rejected: 'Rejeição de solicitação de licenças',
          license_balance_expired_soon: 'Vencimento de saldos',
          license_pending: 'Nova solicitação de licença (Aprovador)'
        },
        bandejaDeTareas: {
          workflow_rejection: 'Rejeição de workflow',
          workflow_revision: 'Workflow em revisão',
          load_documents_approved: 'Aprovação de documento'
        },
        empresa: {
          digital_post: 'Nova notícia',
          onboarding_done: 'Finalização de OnBoarding',
          onboarding: 'Novo Onboarding',
          onboarding_pending: 'Onboarding pendente'
        }
      }
    },
    reports: {
      title: 'Relatórios',
      graphs: {
        graphReceived: {
          title: 'Contracheques totais - Últimos 12 meses',
          label: 'Contracheques'
        },
        graphCompliant: {
          title: 'Contracheques Conformes X não conformes - Últimos 12 meses',
          labels: ['Conformes', 'Não conformes'],
          label: 'Período de'
        },
        graphSigned: {
          title:
            'Contracheques assinados X não assinados - Intervalo de períodos',
          labels: ['Assinados', 'Não assinados'],
          fromPeriod: 'Desde',
          toPeriod: 'Até'
        }
      }
    },
    processManager: {
      title: 'Administrador de processos',
      tableTitle: 'Consulta de status de processos',
      update: 'Atualizar',
      alias: {
        name: 'Nome',
        lastName: 'Sobrenome',
        cuil: 'CPF'
      },
      filters: {
        searchUser: 'Pesquisar usuário',
        noResults: 'Não se encontraram Resultados',
        selectDate: 'Selecione uma data',
        search: 'Pesquisar',
        dateRangeRequired: 'Deve preencher um intervalo de datas',
        selectProcess: 'Selecionar processo'
      },
      table: {
        empty: 'Sem resultados',
        inProgress: 'Em progresso',
        withObservation: 'Completado, mas com observações',
        withError: 'Erro',
        withSuccess: 'Bem-sucedido',
        processed: 'Documentos processados',
        canceled: 'Cancelado',
        continue: 'Continuar',
        user: 'Usuário',
        process: 'Processo',
        created: 'Criado',
        started: 'Iniciado',
        finished: 'Finalizado',
        status: 'Status',
        of: 'de',
        itemsPerPage: 'Quantidade por página'
      },
      errors: {
        CUT_PARAMETERS_NOT_DEFINED:
          'Não se encontraram as configurações necessárias para executar o corte no documento. ',
        CUT_AND_ROTATE_PARAMETERS_NOT_DEFINED:
          'Não se encontraram as configurações necessárias para executar o corte no documento. ',
        ROTATE_PARAMETER_NOT_DEFINED:
          'Não se encontraram as configurações necessárias para executar o corte no documento. ',
        DOCUMENTS_DIRECTORY_INVALID:
          'Não se encontrou a pasta, processo cancelado, por favor entre em contato com suporte.',
        CREATE_CERTIFICATE_DIRECTORY_ERROR:
          'Não foi possível criar a pasta para continuar com o processo de assinatura, processo cancelado, por favor entre em contato com suporte.',
        CREATE_OUTPUT_DIRECTORY_ERROR:
          'Não foi possível criar a pasta para continuar com o processo de assinatura, processo cancelado, por favor entre em contato com suporte.',
        CREATE_ZIP_OUTPUT_DIRECTORY_ERROR:
          'Não foi possível criar a pasta para continuar com o processo de assinatura, processo cancelado, por favor entre em contato com suporte.',
        CREATE_ZIP_FILE_ERROR:
          'Houve um erro na hora de criar o arquivo zip para a publicação. Por favor, tente novamente.',
        CERTIFICATE_NOT_FOUND:
          'Não se encontrou um certificado válido na hora de assinar, por favor tente novamente.',
        CREATE_CERTIFICATE_FILE_ERROR:
          'Não foi possível gerar os arquivos do certificado eletrônico para assinar os documentos, processo cancelado, por favor entre em contato com suporte.',
        CREATE_PRIVATE_KEY_FILE_ERROR:
          'Não foi possível criar a chave privada do certificado eletrônico para assinar os documentos, processo cancelado, por favor entre em contato com suporte.',
        SIGNATURE_PROCESS_ENDS_WITH_ERRORS:
          'Houve uma falha no processo de assinatura de documentos, tente o processo novamente.',
        SIGNATURE_POSITION_INVALID:
          'Foi detectada uma posição de assinatura inválida, por favor, configurar novamente a posição de assinatura no ABM de documentos, antes de tentar novamente o processo.',
        INVALID_PASSPHRASE_FOR_SUPPLIED_PRIVATE_KEY:
          'Erro na hora de validar a chave privada da senha do certificado, deve reiniciar a publicação, processo cancelado.',
        CERTIFICATE_IS_DISABLED:
          'O certificado selecionado não se encontra ativo e é provável que tenha expirado. Por favor, tente com outro certificado ou crie um novo.'
      },
      modal: {
        title: 'Detalhe de processo',
        reportTo: 'Relatório enviado a',
        file: 'Arquivo',
        period: 'Período',
        docQuantity: 'Numero de documentos processados',
        docType: 'Tipo de documento',
        docStatusProcess: 'Clique aqui para baixar a lista de falhas'
      }
    },
    ManagerManagement: {
      title: 'Gestão de manager',
      subtitle: 'Perfis disponíveis',
      formQuestion:
        'Você quer habilitar o perfil de manager de forma automática e massiva?',
      caption:
        'Quando habilitar o perfil de manager, você poderá selecionar as pastas que podem ser visualizadas na plataforma. Por exemplo, se não tiver que acessar os contracheques, desmarcar essa pasta.',
      rbtDisable: 'Não',
      rbtEnable: 'Sim, habilitar',
      seeAllOptions: 'Ver todos',
      inputFolder: {
        title: 'Locação',
        label: 'Seleciona uma pasta',
        clear: 'Limpar seleção',
        noResult: 'Não há pastas'
      },
      cancelModal: {
        title: 'Sair da gestão de manager',
        question: 'Tem certeza de que quer sair da gestão de manager?',
        caption: 'As alterações realizadas não foram salvas',
        cancelBtn: 'Cancelar',
        confirmBtn: 'Sim, sair'
      },
      saveModal: {
        title: 'Salvar perfil manager',
        question:
          'Tem certeza de querer salvar as alterações no perfil manager?',
        caption:
          'Esta alteração vai afetar os {userCount} usuários que já configuraram filtros no perfil de manager ',
        cancelBtn: 'Cancelar',
        confirmBtn: 'Salvar'
      },
      successMessage: 'As alterações foram salvas com sucesso.',
      errorMessage: 'Houve um erro.'
    },
    signatureReminder: {
      title: 'Lembrete de assinatura',
      subtitle: 'Enviar lembrete de documento não assinado',
      body: {
        title: 'Texto a ser enviado:',
        to: 'Prezado,',
        text: 'Lembre que possui documentos disponibilizados na plataforma',
        text1: 'sem sua assinatura.',
        regards: 'Agradecemos sua colaboração.',
        desc: 'Notificação para {quant} usuários com contracheques sem assinar entre os períodos {lastPeriod} e {currentPeriod}',
        noReminder:
          'Não há usuários com contracheques não assinados para notificar'
      },
      button: 'Enviar lembretes'
    },
    documentDetail: {
      uploadTypes: {
        CM: 'Carga Manual',
        KO: 'Kofax',
        CD: 'Carga Massiva',
        EFORMS: 'Eforms'
      },
      title: 'Detalhe de documento',
      buttonReport: 'Relatório Traçabilidade',
      buttonDownload: 'Descarregar Documento',
      buttonDownloadXML: 'Descarregar XML',
      buttonGoBack: 'Voltar',
      empty: {
        title: 'Isto é um deserto...',
        content:
          'O eform se encontra em processo de geração. Logo de assinado será visualizado nesta seção'
      },
      emptyError: {
        title: 'Isto é um deserto...',
        content: 'Não foi possível carregar o arquivo',
        contentCancelled:
          'Não foi possível carregar o arquivo porque o documento está Anulado',
        contentNotFound:
          'O documento não está disponível no momento. Por favor, entre em contato com a equipe de suporte.'
      },
      comments: {
        title: 'Observações',
        buttonAddComment: 'Nova observação',
        empty: {
          title: 'Isto é um deserto',
          content: 'Não se realizaram observações no documento'
        },
        deleteComment: 'Eliminar',
        modal: {
          title: 'Adicionar observação',
          body: 'Observação',
          buttonAdd: 'Salvar',
          buttonCancel: 'Cancelar'
        },
        modalDelete: {
          title: 'Eliminar observação',
          buttonOk: 'Sim, eliminar',
          buttonCancel: 'Cancelar',
          body: 'Tem certeza de que quer eliminar a observação?',
          legend:
            'A observação será eliminada. Esta ação não pode ser desfeita.'
        }
      },
      dataFile: {
        title: 'Dados do arquivo',
        filename: 'Nome',
        origin: 'Origem',
        date: 'Data',
        id: 'ID'
      },
      document: {
        title: 'Documento',
        cuil: 'CPF',
        type: 'Tipo',
        sector: 'Setor',
        location: 'Locação',
        status: 'Status',
        edit: 'Editar',
        delete: 'Eliminar',
        reject: 'Anular',
        cancel: 'Cancelar',
        save: 'Salvar',
        modalCancel: {
          title: 'Anular documento',
          buttonOk: 'Sim, anular',
          buttonCancel: 'Cancelar',
          body: 'Tem certeza de querer anular o documento?',
          legend:
            'O documento será anulado e eliminado de publicações. Esta ação não pode ser desfeita.'
        },
        date: 'Período | Mês e Ano'
      },
      sign: {
        title: 'Assinatura',
        date: 'Data',
        type: 'Tipo de Assinatura',
        finger: 'Finger Print',
        empty: {
          title: 'Isto é um deserto',
          content: 'Não há informação de assinatura para este documento'
        }
      },
      information: {
        cuil: 'CPF',
        entrydate: 'Data de alta',
        email: 'E-mail',
        sector: 'Setor',
        location: 'Locação',
        countsigned: 'Contracheques assinados',
        countunsigned: 'Contracheques não assinados',
        viewEmployeeProfile: 'Ficha do colaborador',
        copyEmail: 'Colar E-mail',
        copiedText: 'Colando e-mail',
        empty: {
          title: 'Isto é um deserto...',
          content:
            'Não existe usuário associado ao {identificator} do documento'
        },
        data: 'Pasta de documentos',
        activity: 'Traçabilidade',
        register: 'Dados'
      },
      errors: {
        default: 'Houve um erro',
        SYSTEM_API_PARAMETER_IS_EMPTY: 'Um ou mais campos são requeridos',
        SYSTEM_API_PARAMETER_REQUIRED: 'Um ou mais campos são requeridos',
        SYSTEM_ACTION_NOT_GRANTED:
          'Você não tem permissão para executar esta ação',
        SYSTEM_API_WRONG_DATA_TYPE: 'Valor de campo incorreto'
      },
      emptyDocument: {
        title: 'Isto é um deserto...',
        content: 'O documento não está disponível'
      },
      commons: {
        cuil: 'CPF'
      },
      informationFile: {
        type: 'Tipo',
        detail: 'Detalhe'
      }
    },
    searchEmployee: {
      notificationReminder: {
        notified: 'Notificados',
        notNotified: 'Não notificados',
        totalNotified: 'Total notificados',
        download: {
          part1: 'Descarregue o',
          part2: 'Relatório de notificações'
        },
        cancel: 'Cancelar',
        send: 'Enviar',
        accept: 'Aceitar'
      },
      tableStatus: {
        inactive: 'Inativo',
        active: 'Ativo',
        total: 'Total'
      },
      add: 'Adicionar',
      onboarding_review_tooltip: 'Porcentagem em revisão. Entre em contato com o suporte.'
    },
    employeePanel: {
      sectionsTitles: {
        personalData: 'Dados pessoais',
        configuration: 'Configuração',
        onboarding: 'Onboarding'
      },
      changeTemplate: {
        currentTemplate: 'Formulário modelo atual',
        newTemplate: 'Novo Formulário',
        message:
          '      Quando trocar o formulário modelo serão perdidos todos os dados que tenha carregado o Funcionário.',
        swal: {
          title: 'Tem certeza de que deseja trocar o formulário modelo?',
          message:
            'Quando trocar o formulário modelo serão perdidos todos os dados que tenha carregado o Funcionário'
        }
      },
      identifyGenre: {
        man: 'Homem',
        woman: 'Mulher',
        noBinary: 'Não binário',
        other: 'Prefiro não indicar'
      },
      fieldValidation: 'Não se permitem traços',
      importantTitle: 'Importante',
      noValidCuil: 'O CPF não deve conter traços.',
      userAccount: 'Conta Salário',
      userAccountCTS: 'Conta CTS',
      particularAddress: 'Particular',
      onboardingActivate: 'Ativar Onboarding',
      errorDoc: 'Houve um erro na hora de processar o documento',
      errorDocMultiple: 'Houve um erro na hora processar os documentos',
      requestDoc: 'Solicitar carregar novamente o documento.',
      requestDocMultiple: 'Solicitar carregar novamente os documentos.',
      buttonCancel: 'Cancelar',
      buttonRequest: 'Solicitar'
    },
    billboard: {
      dragItems:
        '(arraste os elementos de um campo para o outro para inclui-los)',
      placeholderTitle: 'Título',
      placeholderVideo: 'URL vídeo',
      chars: 'Caracteres',
      total1: '/255',
      total2: '/1000',
      formats: 'PDF, JPG, JPEG, PNG',
      employeeNotify: 'Notificar via e-mail aos Funcionários',
      search: 'Procurar',
      table: {
        title: 'Título',
        status: 'Status'
      },
      days_left: {
        many: 'Faltam',
        one: 'Falta',
        days: 'dias',
        day: 'dia'
      },
      empty_state: {
        title: 'Hoje não há notícias vigentes',
        description:
          'Nesta seção você vai poder publicar vídeos, PDFs, imagens etc.'
      },
      errors: {
        invalidUrl: 'A URL não é válida'
      }
    },
    filterBar: {
      formName: 'Nome formulário',
      filters: 'Filtros',
      form: 'Formulário',
      selfService: 'Autogestão',
      status: 'Status',
      active: 'Ativo',
      inactive: 'Inativo',
      packages: 'Pacotes de envios',
      select: 'Selecione...'
    },
    notificationModal: {
      title: 'Publicação sem notificação a Funcionários',
      description: 'Você vai fazer uma publicação que',
      noNotify: 'não vai notificar a seus Funcionários',
      publishWithout: 'Publicar sem notificação',
      publishWith: 'Publicar com notificação'
    },
    completePublishModal: {
      title: 'Documento novo',
      question: 'Você quer carregar outro documento?',
      description:
        'Você pode carregar outro documento preenchendo ou ir para o detalhe',
      description2: 'do documento já carregado',
      uploadAnother: 'Carregar outro documento',
      goToDetail: 'Ir para o detalhe'
    },
    pickup: {
      title: 'Configuração do formulário digital',
      newForm: '+ Novo Formulário',
      error: 'Error:',
      table: {
        name: 'Nome',
        status: 'Estado',
      },
       label: {
        title: 'Autogestão',
        certificate: 'Certificado'
      }
    }
  }
}
